import React, {Component} from 'react';
import css from './LeadDetails.module.scss';
import Accordion from "../../components/Accordion/Accordion";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes, faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-modal';
import axios from 'axios';
import moment from 'moment';
import he from 'he';
import {connect} from "react-redux";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/dark.css";
import formatDataText from '../../utils/formatDataText';
import formatShortDate from '../../utils/formatShortDate';
import {Link} from "react-router-dom";
import ErrorLabel from "../../components/ErrorLabel/ErrorLabel";
import _ from 'lodash';
import getMasterTariff from "../../helpers/masterTariffHelper";
import tunaXML from "../../helpers/creditCheckBuilder";
import Downshift from 'downshift';
import getPandaDocFields from "../../helpers/pandaDocBuilderNew";
import getPandaDocFieldsBattery from "../../helpers/pandaDocBuilderBattery";


/**
 * @class
 *
 * Lead Details page.
 *
 * N.b. we create a ref <https://reactjs.org/docs/refs-and-the-dom.html>, `refEditLead`, on the Formik form. This allows us to call the
 * `saveLeadOnClick` outside the Formik form.
 */
const LeadDetails = class extends Component {
    // ---------- class fields: ----------
    source = axios.CancelToken.source();

    leadId = this.props.match.params.id;

    leadStatusOptions = [
        'Accepted',
        'Contact Attempted',
        'Working',
        'Appointment Set',
        'Presented Proposal',
        'Appointment Completed',
        'Appointment Rescheduled',
        'Nurturing',
        'Rejected',
        'Unqualified',
        'Super Dead'
    ];

    leadPurposeOptions = [
        'Usage Only',
        'Office Proposal Generation',
        'Sales Proposal Generation'
    ]

    refEditLead = React.createRef();

    messageGroupTypes = [
        'Proposal',
        'Contract Work',
        'Customer Service',
        'Supervisor',
    ];

    postRequestAttempts = {
        "limit": 25,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "Call_Outcome__c",
            "Customer_Name__c",
            "Notes__c",
            "Type__c",
            "Sales_Rep__c",
            "CreatedDate"
        ],
        "where": {
            "Customer_Name__c": this.props.match.params.id
        }
    };

    postRequestChatter = {
        "recordIds": [this.props.match.params.id]
    };

    // ---------- state: ----------
    state = {
        isModelOpen: false,
        logAttemptNotes: '',
        logAttemptType: '',
        logAttemptOutcome: '',
        isEditingLead: false,
        lead: {},
        attempts: [],
        chatter: [],
        prelimAppointmentTime: '',
        satTime: '',
        usageModalOpen: false,
        usageCalcType: '',
        utilProvider: '',
        utilCCA: '',
        utilRateSched: '',
        janUsage: '',
        janMonBill: '',
        febUsage: '',
        febMonBill: '',
        marUsage: '',
        marMonBill: '',
        aprUsage: '',
        aprMonBill: '',
        mayUsage: '',
        mayMonBill: '',
        junUsage: '',
        junMonBill: '',
        julUsage: '',
        julMonBill: '',
        augUsage: '',
        augMonBill: '',
        sepUsage: '',
        sepMonBill: '',
        octUsage: '',
        octMonBill: '',
        novUsage: '',
        novMonBill: '',
        decUsage: '',
        decMonBill: '',
        averageKWH: 0,
        annualTotal: 0,
        rateOptions: [],
        calcRan: false,
        disableSubmit: false,
        prelimProposal: {},
        pricingModalOpen: false,
        cashPricingModal: false,
        pricingMethod: '',
        proposalType: '',
        ppw: 0,
        kwh: 0,
        amount: 0,
        pricingData: [],
        displayedKWH: 0,
        displayedPPW: 0,
        displayedAmount: 0,
        kwhError: '',
        monthlyBill: 0,
        leadConvertModalIsOpen: false,
        leadConvertSuccess: false,
        leadConvertFailed: false,
        leadConvertProcessing: false,
        leadConvertConfirm: true,
        disableSavePricing: false,
        auroraId: '',
        optionsUtilityProvider: [],
        disableAuroraButton: false,
        dobCredit: '',
        creditResult: '',
        creditScore: '',
        runCreditDisabled: false,
        disablePricingButton: true,
        titleCheckButtonDisabled: false,
        primaryTitle: '',
        secondaryTitle: '',
        homeType: '',
        disableSaveUsage: true,
        usageRecord: [],
        checkAddressModal: false,
        missingCloserModal: false,
        checkingAddress: true,
        creatingAuroraProject: true,
        prodRatioCheck: 0,
        leadNotes: '',
        leadNotesDisabled: false,
        leadNoteSaveSuccess: false,
        items: [],
        selectedRep: '',
        firstRep: '',
        secondRep: '',
        sendAgreementDisabled: false,
        repIdForContract: '',
        contractReps: [],
        agreementReps: [],
        newContract: {},
        agreementConfirm: false,
        repContactForDocs: {},
        batteryCommissionValues: [],
        emptyMatrixError:'',
        optionsPreferredFinancier: [],
        existingCustomer: 'No',
        monitorMain: false,
        auroraUserId: '',
        evebrightId: '',
        leadUtilityProvider: '',
        availableUtilityProviders: [],
        isUserCloser: false,
        leadNameEditDisabled: false,
        optionsCustomerType: []
    };

    // ---------- life cycle methods: ----------
    async componentDidMount() {
        window.scrollTo(0, 0);

        const lead = await this.getLead();
        await this.getActiveReps(lead.Sales_Representative__c, lead.Sales_Representative_2__c);
        await this.getUtilityRecords(lead);

        if(lead.Active_Prelim_Proposal__c !== null){
            const prop = await this.getProposal(lead.Active_Prelim_Proposal__c);
            const prodRatio2 = prop.Production_Ratio__c > 2000 ? 2000 : prop.Production_Ratio__c;
            const prodRatioFloor = Math.floor(prodRatio2 / 25) * 25;
            const utilityName = prop?.Lead__r?.Utility__r?.Name ?? "";
            const recordTypeName = prop?.RecordType?.Name ?? "";
            await this.getPricingData(prodRatioFloor, '3.50', utilityName, recordTypeName);
        }

        await Promise.all([
            this.getChatter(),
            this.getFieldDetails(),
            this.getUsage(),
            this.getAttempts(),
        ]);
    }

    componentWillUnmount() {
        this.source.cancel();
    }

    // ---------- methods: ----------
    saveLeadOnClick = () => {
        if (this.refEditLead.current) {
            this.refEditLead.current.handleSubmit();
        }
    };

    toggleEditLead = (isEditingLead) => {
        this.setState({ isEditingLead });
    };

    getLead = () => {
        return axios.get(
            `/sf/lead/findOne/${this.leadId}`,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data;

                // set initial prelim apt. time:
                let prelimAppointmentTime = '';

                if (data.Prelim_Appointment_Time__c) {
                    prelimAppointmentTime = new Date(data.Prelim_Appointment_Time__c)
                }

                if(data.Preferred_Financier__c === null || data.Preferred_Financier__c === ''){
                    this.setState({disableAuroraButton: true});
                } else {
                    this.setState({disableAuroraButton: false});
                }

                if(data.Active_Prelim_Proposal__c === null && data.Preferred_Financier__c === 'Everbright' && data.Everbright_Site_Id__c !== null) {
                    this.setState({disablePricingButton: false});
                }

                this.setState({
                    prelimAppointmentTime: prelimAppointmentTime,
                    lead: data,
                    leadNotes: data.Sales_Notes__c
                });

                // ensure forms are in 'display mode' rather than 'edit mode':
                this.toggleEditLead(false);
                return data;
            })
            .catch(err =>{ 
                console.log('(GET) Error tyring to fetch lead records: ', err);
                return null;
            });
    };

    getActiveReps = async(rep1, rep2) => {
        let activeRepPayload = {
            "limit": 500,
            "skip": 0,
            "fields": [
                "Id",
                "Name",
                "HIS_License__c",
                "Active__c",
                "Sales_Role__c"
            ],
            "where": {
                // Either is an active rep or is in opportunity's sales rep lookups. This way even if rep is inactive, it will show on the page.
                "$or": [
                    {
                        "$and": [
                            { "Active__c": true },
                            { "Job_Department__c": "Sales" }
                        ]
                    },
                    {
                        "Id": { "$in": [rep1, rep2] }
                    }
                ]
            }
        };

        await axios.post(
            '/sf/contact/findNo',
            activeRepPayload,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data;
                const reps = [];

                _.each(data.records, function(v){
                    reps.push({value: v.Name, id: v.Id, hisLicense: v.HIS_License__c, active: v.Active__c, role: v.Sales_Role__c});
                });
                reps.push({value: ':Remove Rep', id: 'Remove'});

                const filterReps = _.uniqBy(reps, function(o) { return o.value; });
                const orderedReps = _.orderBy(filterReps, ['value']);

                let secondRep = '';
                let contractReps = [];
                let agreementReps = [];
                const foundRep1 = _.find(orderedReps, ['id', this.state.lead.Sales_Representative__c]);
                let firstRep = foundRep1.value;

                if(foundRep1.active == true){
                    contractReps.push({value: foundRep1.value, id: this.state.lead.Sales_Representative__c});

                    if(foundRep1.hisLicense !== null){
                        agreementReps.push({value: foundRep1.value, id: this.state.lead.Sales_Representative__c});
                    }
                }

                if(this.state.lead.Sales_Representative_2__c !== null) {
                    const foundRep = _.find(orderedReps, ['id', this.state.lead.Sales_Representative_2__c]);
                    secondRep = foundRep.value;

                    if(foundRep.active == true){
                        contractReps.push({value: foundRep.value, id: this.state.lead.Sales_Representative_2__c});

                        if(foundRep.hisLicense !== null){
                            agreementReps.push({value: foundRep.value, id: this.state.lead.Sales_Representative_2__c});
                        }
                    }
                }

                const userContactId = this.props.user?.apiId; // contact id that is used to connect to salesforce. E.g. contact id of the logged in user.
                let isUserCloser = false;

                if(userContactId){
                    const foundContact = _.find(orderedReps, ['id', userContactId]);
                    isUserCloser = foundContact?.role === 'Closer';
                }

                this.setState({
                    items: orderedReps,
                    firstRep: firstRep,
                    secondRep: secondRep,
                    contractReps: contractReps,
                    agreementReps: agreementReps,
                    isUserCloser: isUserCloser
                });
            })
            .catch(err => console.log('(GET) Error tyring to fetch active reps: ', err));
    };

    getFieldDetails = async () => {
        await axios.get(
            '/sf/proposal/describeField/Battery_Commission__c',
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                let batArray = res.data.picklistValues;
                let batFilt = _.reject(batArray, function(o) { return o.value === '500' || o.value === '1500' || o.value === '2500'; });

                this.setState({
                    batteryCommissionValues: batFilt
                });
            })
            .catch(err => console.log('(GET) Error tyring to fetch Battery Commission options: ', err));
        
        await axios.get(
            '/sf/lead/describeField/Preferred_Financier__c',
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({
                    optionsPreferredFinancier: res.data.picklistValues
                });
            });

        await axios.get(
            '/sf/lead/describeField/Customer_Type__c',
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({
                    optionsCustomerType: res.data.picklistValues
                });
            });
    };

    getUtilityRecords = async(lead) => {
        let postRequestUtilities = {
            "limit": 500,
            "skip": 0,
            "fields": [
                "Id",
                "Name",
                "Active__c",
                "State__c"
            ],
            "where": {
                "Active__c": true
            }
        };

        await axios.post(
            '/sf/Utility/findNO',
            postRequestUtilities,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data;
                const utilities = [];
                const leadState = lead.State;

                _.each(data.records, function(v){
                    if(v.Active__c === true && v.State__c === leadState){
                        utilities.push({value: v.Name, id: v.Id});
                    }
                });

                const orderedUtilities = _.orderBy(utilities, ['value']);
                const leadUtility = _.find(utilities, ['id', lead.Utility__c]);
                const leadUtilityName = leadUtility ? leadUtility.value : '';
                this.setState({leadUtilityProvider: leadUtilityName, availableUtilityProviders: orderedUtilities});
            })
            .catch(err => console.log('(GET) Error querying Utility Providers: ', err));
    }

    getProposal = (prelimPropId) => {
        let postRequestProposal = {
            "limit": 1,
            "skip": 0,
            "fields": [
                "Id",
                "Name",
                "Price_per_Watt__c",
                "Price_per_kWh__c",
                "Est_Year_One_Production__c",
                "System_Size__c",
                "EPC__c",
                "Annual_Usage__c",
                "Rep_Generated__c",
                "Escalator__c",
                "Price_Calc_Method__c",
                "Production_Ratio__c",
                "Monthly_Bill_Amount__c",
                "RecordTypeId",
                "Battery_Type__c",
                "Battery_Type__r.Name",
                "Number_of_Batteries__c",
                "Monthly_Battery_Amount__c",
                "Total_Monthly_Payment__c",
                "Contract_New__c",
                "Contract_New__r.Status__c",
                "Battery_Commission__c",
                "Type__c",
                "Financing_Partner__c",
                "Amount__c",
                "Monitoring_Maintenance_25_Years__c",
                "Lead__r.Utility__r.Name",
                "RecordType.Name",
            ],
            "where": {
                "Id": prelimPropId,
                "Active__c": true
            }
        };

        return axios.post(
            '/sf/Proposal/findNO',
            postRequestProposal,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data.records[0];
                let formatPPW = Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(data.Price_per_Watt__c);
                let formatKWH = Intl.NumberFormat('en-US', {style:'currency',currency: 'USD', minimumFractionDigits: 3}).format(data.Price_per_kWh__c);
                let prodRatio = data.Est_Year_One_Production__c / data.System_Size__c;

                this.setState({
                    prelimProposal: data,
                    ppw: data.Price_per_Watt__c,
                    displayedPPW: formatPPW,
                    kwh: data.Price_per_kWh__c,
                    displayedKWH: formatKWH,
                    monthlyBill: data.Monthly_Bill_Amount__c,
                    prodRatioCheck: prodRatio,
                    leadNameEditDisabled: (data.Contract_New__c !== null)
                }); 

                if(this.state.lead.Preferred_Financier__c === 'Everbright' && this.state.lead.Everbright_Site_Id__c === null) {
                    this.setState({disablePricingButton: true});
                } else if(this.state.lead.Preferred_Financier__c === 'Goodleap' && this.state.lead.Aurora_System_Project_Id__c !== null) {
                    this.setState({disablePricingButton: true});
                } else {
                    this.setState({disablePricingButton: false});
                }

                return data;
            })
            .catch(err =>{
                console.log('(GET) Error querying Prelim Proposal: ', err);
                return null;
            });
    };

    getPricingData = async (prodRatio, escalator, utility, proposalType) => {
        let postReq = {
            "skip": 0,
            "fields": [
                "Id",
                "Name",
                "Escalator__c",
                "Production_Ratio__c",
                "Price_per_Watt__c",
                "Rate__c"
            ],
            "where": {
                "Active__c": true,
                "Production_Ratio__c": prodRatio,
                "Escalator__c": escalator,
                "Utility__c": utility,
                "Proposal_Type__c": proposalType
            }
        };

        await axios.post(
            '/sf/Pricing/findNO',
            postReq,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data.records;
                this.setState({pricingData:data});
            })
            .catch(err => console.log('(GET) Error querying V3 Pricing: ', err));
    };

    getChatter = async () => {
        await axios.post(
            '/sf/chatter/records',
            this.postRequestChatter,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                // fetch updated chatter records:
                // condition to guard non-existent data:
                if (res.data.results.length && res.data.results[0].result) {
                    let scopedChatter = []; 
                    _.each(res.data.results[0].result.elements, function(c){
                        if(c.body.text){
                            if(c.body.text.includes('@Reps')){
                                scopedChatter.push(c);
                            }
                        }
                    });

                    this.setState({
                        chatter: scopedChatter
                    });
                }
            })
            .catch(err => console.log('(POST) err from sf/chatter/records: ', err));
    };

    getAttempts = async () => {
        await axios.post(
            '/sf/attempt/findNo',
            this.postRequestAttempts,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({
                    attempts: res.data.records
                });
            })
            .catch(err => console.log('(POST) Error from sf/attempt/findNo: ', err));
    };

    getUsage = async () => {
        let getUsagePayload = {
            "limit": 1,
            "fields": [
                "Id",
                "January_Usage__c",
                "January_Bill__c",
                "February_Usage__c",
                "February_Bill__c",
                "March_Usage__c",
                "March_Bill__c",
                "April_Usage__c",
                "April_Bill__c",
                "May_Usage__c",
                "May_Bill__c",
                "June_Usage__c",
                "June_Bill__c",
                "July_Usage__c",
                "July_Bill__c",
                "August_Usage__c",
                "August_Bill__c",
                "September_Usage__c",
                "September_Bill__c",
                "October_Usage__c",
                "OCtober_Bill__c",
                "November_Usage__c",
                "November_Bill__c",
                "December_Usage__c",
                "December_Bill__c"
            ],
            "where": {
                "Lead__c": this.props.match.params.id
            }
        };

        await axios.post(
            '/sf/usage/findNO',
            getUsagePayload,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                if(res.data.records.length !== 0){
                    this.setState({usageRecord: res.data.records[0]});
                }
            })
            .catch(err => console.log('(GET) Error querying Usage: ', err));
    };

    modalLogAttemptOnClick = () => {
        const payload = {
            Name: "Lead Attempt",
            Sales_Rep__c: this.props.user.apiId,
            Type__c: this.state.logAttemptType,
            Customer_Name__c: this.leadId,
            Notes__c: this.state.logAttemptNotes,
            Call_Outcome__c: this.state.logAttemptType === 'Call' ? this.state.logAttemptOutcome : ''
        };

        axios.post(
            '/sf/attempt/create',
            payload,
            {
                cancelToken: this.source.token
            })
            .then(() => {
                // fetch updated attempts:
                this.getAttempts();

                // clear modal form and close modal:
                this.setState({
                    isModelOpen: false,
                    logAttemptType: '',
                    logAttemptNotes: '',
                    logAttemptOutcome: ''
                });
            })
            .catch(err => console.log('(POST) Error while trying to add new log attempt:\n', err));
    };

    genUsageOnClick = () => {
        this.setState({calcRan: true});
        const today = new Date();
        let payload = [];
        let fromDate;
        let toDate;
        let mIdObj;
        let averageKWH = 0;
        let annualTotal = 0;

        if(this.state.utilCCA !== ''){
            mIdObj = {...getMasterTariff(this.state.utilCCA, this.state.utilRateSched)};
        } else {
            mIdObj = {...getMasterTariff(this.state.utilProvider, this.state.utilRateSched)};
        }

        const mId = _.values(mIdObj);

        if(this.state.usageCalcType === 'Usage'){
            if(this.state.janUsage !== ''){
                if(today.getMonth() >= 0){
                    fromDate = today.getFullYear() + "-01-01";
                    toDate = today.getFullYear() + "-02-01"
                } else {
                    fromDate = today.getFullYear() - 1 + "-01-01";
                    toDate = today.getFullYear() - 1 + "-02-01"
                }
                const req = this.buildUsagePayload(this.state.janUsage, fromDate, toDate, mId.join(''));
                payload.push(req);

                averageKWH = averageKWH + parseInt(this.state.janUsage);
            }
            if(this.state.febUsage !== ''){
                if(today.getMonth() >= 1){
                    fromDate = today.getFullYear() + "-02-01";
                    toDate = today.getFullYear() + "-03-01"
                } else {
                    fromDate = today.getFullYear() - 1 + "-02-01";
                    toDate = today.getFullYear() - 1 + "-03-01"
                }
                const req = this.buildUsagePayload(this.state.febUsage, fromDate, toDate, mId.join(''));
                payload.push(req);

                averageKWH = parseInt(this.state.febUsage) + averageKWH;
            }
            if(this.state.marUsage !== ''){
                if(today.getMonth() >= 2){
                    fromDate = today.getFullYear() + "-03-01";
                    toDate = today.getFullYear() + "-04-01"
                } else {
                    fromDate = today.getFullYear() - 1 + "-03-01";
                    toDate = today.getFullYear() - 1 + "-04-01"
                }
                const req = this.buildUsagePayload(this.state.marUsage, fromDate, toDate, mId.join(''));
                payload.push(req);

                averageKWH = parseInt(this.state.marUsage) + averageKWH;
            }
            if(this.state.aprUsage !== ''){
                if(today.getMonth() >= 3){
                    fromDate = today.getFullYear() + "-04-01";
                    toDate = today.getFullYear() + "-05-01"
                } else {
                    fromDate = today.getFullYear() - 1 + "-04-01";
                    toDate = today.getFullYear() - 1 + "-05-01"
                }
                const req = this.buildUsagePayload(this.state.aprUsage, fromDate, toDate, mId.join(''));
                payload.push(req);

                averageKWH = parseInt(this.state.aprUsage) + averageKWH;
            }
            if(this.state.mayUsage !== ''){
                if(today.getMonth() >= 4){
                    fromDate = today.getFullYear() + "-05-01";
                    toDate = today.getFullYear() + "-06-01"
                } else {
                    fromDate = today.getFullYear() - 1 + "-05-01";
                    toDate = today.getFullYear() - 1 + "-06-01"
                }
                const req = this.buildUsagePayload(this.state.mayUsage, fromDate, toDate, mId.join(''));
                payload.push(req);

                averageKWH = parseInt(this.state.mayUsage) + averageKWH;
            }
            if(this.state.junUsage !== ''){
                if(today.getMonth() >= 5){
                    fromDate = today.getFullYear() + "-06-01";
                    toDate = today.getFullYear() + "-07-01"
                } else {
                    fromDate = today.getFullYear() - 1 + "-06-01";
                    toDate = today.getFullYear() - 1 + "-07-01"
                }
                const req = this.buildUsagePayload(this.state.junUsage, fromDate, toDate, mId.join(''));
                payload.push(req);

                averageKWH = parseInt(this.state.junUsage) + averageKWH;
            }
            if(this.state.julUsage !== ''){
                if(today.getMonth() >= 6){
                    fromDate = today.getFullYear() + "-07-01";
                    toDate = today.getFullYear() + "-08-01"
                } else {
                    fromDate = today.getFullYear() - 1 + "-07-01";
                    toDate = today.getFullYear() - 1 + "-08-01"
                }
                const req = this.buildUsagePayload(this.state.julUsage, fromDate, toDate, mId.join(''));
                payload.push(req);

                averageKWH = parseInt(this.state.julUsage) + averageKWH;
            }
            if(this.state.augUsage !== ''){
                if(today.getMonth() >= 7){
                    fromDate = today.getFullYear() + "-08-01";
                    toDate = today.getFullYear() + "-09-01"
                } else {
                    fromDate = today.getFullYear() - 1 + "-08-01";
                    toDate = today.getFullYear() - 1 + "-09-01"
                }
                const req = this.buildUsagePayload(this.state.augUsage, fromDate, toDate, mId.join(''));
                payload.push(req);

                averageKWH = parseInt(this.state.augUsage) + averageKWH;
            }
            if(this.state.sepUsage !== ''){
                if(today.getMonth() >= 8){
                    fromDate = today.getFullYear() + "-09-01";
                    toDate = today.getFullYear() + "-10-01"
                } else {
                    fromDate = today.getFullYear() - 1 + "-09-01";
                    toDate = today.getFullYear() - 1 + "-10-01"
                }
                const req = this.buildUsagePayload(this.state.sepUsage, fromDate, toDate, mId.join(''));
                payload.push(req);

                averageKWH = parseInt(this.state.sepUsage) + averageKWH;
            }
            if(this.state.octUsage !== ''){
                if(today.getMonth() >= 9){
                    fromDate = today.getFullYear() + "-10-01";
                    toDate = today.getFullYear() + "-11-01"
                } else {
                    fromDate = today.getFullYear() - 1 + "-10-01";
                    toDate = today.getFullYear() - 1 + "-11-01"
                }
                const req = this.buildUsagePayload(this.state.octUsage, fromDate, toDate, mId.join(''));
                payload.push(req);

                averageKWH = parseInt(this.state.octUsage) + averageKWH;
            }
            if(this.state.novUsage !== ''){
                if(today.getMonth() >= 10){
                    fromDate = today.getFullYear() + "-11-01";
                    toDate = today.getFullYear() + "-12-01"
                } else {
                    fromDate = today.getFullYear() - 1 + "-11-01";
                    toDate = today.getFullYear() - 1 + "-12-01"
                }
                const req = this.buildUsagePayload(this.state.novUsage, fromDate, toDate, mId.join(''));
                payload.push(req);

                averageKWH = parseInt(this.state.novUsage) + averageKWH;
            }
            if(this.state.decUsage !== ''){
                if(today.getMonth() >= 11){
                    fromDate = today.getFullYear() + "-12-01";
                    toDate = today.getFullYear() + 1 + "-01-01"
                } else {
                    fromDate = today.getFullYear() - 1 + "-12-01";
                    toDate = today.getFullYear() + 1 + "-01-01"
                }
                const req = this.buildUsagePayload(this.state.decUsage, fromDate, toDate, mId.join(''));
                payload.push(req);

                averageKWH = parseInt(this.state.decUsage) + averageKWH;
            }
        } else {
            if(this.state.janMonBill !== ''){
                if(today.getMonth() >= 0){
                    fromDate = today.getFullYear() + "-01-01";
                    toDate = today.getFullYear() + "-02-01"
                } else {
                    fromDate = today.getFullYear() - 1 + "-01-01";
                    toDate = today.getFullYear() - 1 + "-02-01"
                }
                const req = this.buildUsagePayload(this.state.janMonBill, fromDate, toDate, mId.join(''));
                payload.push(req);

                annualTotal = annualTotal + parseInt(this.state.janMonBill);
            }
            if(this.state.febMonBill !== ''){
                if(today.getMonth() >= 1){
                    fromDate = today.getFullYear() + "-02-01";
                    toDate = today.getFullYear() + "-03-01"
                } else {
                    fromDate = today.getFullYear() - 1 + "-02-01";
                    toDate = today.getFullYear() - 1 + "-03-01"
                }
                const req = this.buildUsagePayload(this.state.febMonBill, fromDate, toDate, mId.join(''));
                payload.push(req);

                annualTotal = annualTotal + parseInt(this.state.febMonBill);
            }
            if(this.state.marMonBill !== ''){
                if(today.getMonth() >= 2){
                    fromDate = today.getFullYear() + "-03-01";
                    toDate = today.getFullYear() + "-04-01"
                } else {
                    fromDate = today.getFullYear() - 1 + "-03-01";
                    toDate = today.getFullYear() - 1 + "-04-01"
                }
                const req = this.buildUsagePayload(this.state.marMonBill, fromDate, toDate, mId.join(''));
                payload.push(req);

                annualTotal = annualTotal + parseInt(this.state.marMonBill);
            }
            if(this.state.aprMonBill !== ''){
                if(today.getMonth() >= 3){
                    fromDate = today.getFullYear() + "-04-01";
                    toDate = today.getFullYear() + "-05-01"
                } else {
                    fromDate = today.getFullYear() - 1 + "-04-01";
                    toDate = today.getFullYear() - 1 + "-05-01"
                }
                const req = this.buildUsagePayload(this.state.aprMonBill, fromDate, toDate, mId.join(''));
                payload.push(req);

                annualTotal = annualTotal + parseInt(this.state.aprMonBill);
            }
            if(this.state.mayMonBill !== ''){
                if(today.getMonth() >= 4){
                    fromDate = today.getFullYear() + "-05-01";
                    toDate = today.getFullYear() + "-06-01"
                } else {
                    fromDate = today.getFullYear() - 1 + "-05-01";
                    toDate = today.getFullYear() - 1 + "-06-01"
                }
                const req = this.buildUsagePayload(this.state.mayMonBill, fromDate, toDate, mId.join(''));
                payload.push(req);

                annualTotal = annualTotal + parseInt(this.state.mayMonBill);
            }
            if(this.state.junMonBill !== ''){
                if(today.getMonth() >= 5){
                    fromDate = today.getFullYear() + "-06-01";
                    toDate = today.getFullYear() + "-07-01"
                } else {
                    fromDate = today.getFullYear() - 1 + "-06-01";
                    toDate = today.getFullYear() - 1 + "-07-01"
                }
                const req = this.buildUsagePayload(this.state.junMonBill, fromDate, toDate, mId.join(''));
                payload.push(req);

                annualTotal = annualTotal + parseInt(this.state.junMonBill);
            }
            if(this.state.julMonBill!== ''){
                if(today.getMonth() >= 6){
                    fromDate = today.getFullYear() + "-07-01";
                    toDate = today.getFullYear() + "-08-01"
                } else {
                    fromDate = today.getFullYear() - 1 + "-07-01";
                    toDate = today.getFullYear() - 1 + "-08-01"
                }
                const req = this.buildUsagePayload(this.state.julMonBill, fromDate, toDate, mId.join(''));
                payload.push(req);

                annualTotal = annualTotal + parseInt(this.state.julMonBill);
            }
            if(this.state.augMonBill !== ''){
                if(today.getMonth() >= 7){
                    fromDate = today.getFullYear() + "-08-01";
                    toDate = today.getFullYear() + "-09-01"
                } else {
                    fromDate = today.getFullYear() - 1 + "-08-01";
                    toDate = today.getFullYear() - 1 + "-09-01"
                }
                const req = this.buildUsagePayload(this.state.augMonBill, fromDate, toDate, mId.join(''));
                payload.push(req);

                annualTotal = annualTotal + parseInt(this.state.augMonBill);
            }
            if(this.state.sepMonBill !== ''){
                if(today.getMonth() >= 8){
                    fromDate = today.getFullYear() + "-09-01";
                    toDate = today.getFullYear() + "-10-01"
                } else {
                    fromDate = today.getFullYear() - 1 + "-09-01";
                    toDate = today.getFullYear() - 1 + "-10-01"
                }
                const req = this.buildUsagePayload(this.state.sepMonBill, fromDate, toDate, mId.join(''));
                payload.push(req);

                annualTotal = annualTotal + parseInt(this.state.sepMonBill);
            }
            if(this.state.octMonBill !== ''){
                if(today.getMonth() >= 9){
                    fromDate = today.getFullYear() + "-10-01";
                    toDate = today.getFullYear() + "-11-01"
                } else {
                    fromDate = today.getFullYear() - 1 + "-10-01";
                    toDate = today.getFullYear() - 1 + "-11-01"
                }
                const req = this.buildUsagePayload(this.state.octMonBill, fromDate, toDate, mId.join(''));
                payload.push(req);

                annualTotal = annualTotal + parseInt(this.state.octMonBill);
            }
            if(this.state.novMonBill !== ''){
                if(today.getMonth() >= 10){
                    fromDate = today.getFullYear() + "-11-01";
                    toDate = today.getFullYear() + "-12-01"
                } else {
                    fromDate = today.getFullYear() - 1 + "-11-01";
                    toDate = today.getFullYear() - 1 + "-12-01"
                }
                const req = this.buildUsagePayload(this.state.novMonBill, fromDate, toDate, mId.join(''));
                payload.push(req);

                annualTotal = annualTotal + parseInt(this.state.novMonBill);
            }
            if(this.state.decMonBill !== ''){
                if(today.getMonth() >= 11){
                    fromDate = today.getFullYear() + "-12-01";
                    toDate = today.getFullYear() + 1 + "-01-01"
                } else {
                    fromDate = today.getFullYear() - 1 + "-12-01";
                    toDate = today.getFullYear() + 1 + "-01-01"
                }
                const req = this.buildUsagePayload(this.state.decMonBill, fromDate, toDate, mId.join(''));
                payload.push(req);

                annualTotal = annualTotal + parseInt(this.state.decMonBill);
            }
        }

        this.setState({
            averageKWH: averageKWH / 12,
            annualTotal: annualTotal
        });

        payload.forEach(item => 
        
            axios.post(
                '/genUsage',
                item,
                {
                    cancelToken: this.source.token
                })
                .then((res) => {
                    let d = new Date(item.fromDateTime + "T08:00:00Z");
                    let annualTotal = this.state.annualTotal;
                    let averageKWH = this.state.averageKWH;

                    if(this.state.usageCalcType === 'Usage'){
                        switch(d.getMonth()) {
                            case 0:
                                this.setState({
                                    janMonBill: res.data.results[0].totalCost,
                                    annualTotal: res.data.results[0].totalCost + annualTotal
                                });
                                break;
                            case 1:
                                this.setState({
                                    febMonBill: res.data.results[0].totalCost,
                                    annualTotal: res.data.results[0].totalCost + annualTotal
                                });
                                break;
                            case 2:
                                this.setState({
                                    marMonBill: res.data.results[0].totalCost,
                                    annualTotal: res.data.results[0].totalCost + annualTotal
                                });
                                break;
                            case 3:
                                this.setState({
                                    aprMonBill: res.data.results[0].totalCost,
                                    annualTotal: res.data.results[0].totalCost + annualTotal
                                });
                                break;
                            case 4:
                                this.setState({
                                    mayMonBill: res.data.results[0].totalCost,
                                    annualTotal: res.data.results[0].totalCost + annualTotal
                                });
                                break;
                            case 5:
                                this.setState({
                                    junMonBill: res.data.results[0].totalCost,
                                    annualTotal: res.data.results[0].totalCost + annualTotal
                                });
                                break;
                            case 6:
                                this.setState({
                                    julMonBill: res.data.results[0].totalCost,
                                    annualTotal: res.data.results[0].totalCost + annualTotal
                                });
                                break;
                            case 7:
                                this.setState({
                                    augMonBill: res.data.results[0].totalCost,
                                    annualTotal: res.data.results[0].totalCost + annualTotal
                                });
                                break;
                            case 8:
                                this.setState({
                                    sepMonBill: res.data.results[0].totalCost,
                                    annualTotal: res.data.results[0].totalCost + annualTotal
                                });
                                break;
                            case 9:
                                this.setState({
                                    octMonBill: res.data.results[0].totalCost,
                                    annualTotal: res.data.results[0].totalCost + annualTotal
                                });
                                break;
                            case 10:
                                this.setState({
                                    novMonBill: res.data.results[0].totalCost,
                                    annualTotal: res.data.results[0].totalCost + annualTotal
                                });
                                break;
                            case 11:
                                this.setState({
                                    decMonBill: res.data.results[0].totalCost,
                                    annualTotal: res.data.results[0].totalCost + annualTotal
                                });
                                break;
                            default:
                                break;
                        }
                    } else {
                        switch(d.getMonth()) {
                            case 0:
                                this.setState({
                                    janUsage: res.data.results[0].summary.kWh,
                                    averageKWH: res.data.results[0].summary.kWh + averageKWH
                                });
                                break;
                            case 1:
                                this.setState({
                                    febUsage: res.data.results[0].summary.kWh,
                                    averageKWH: res.data.results[0].summary.kWh + averageKWH
                                });
                                break;
                            case 2:
                                this.setState({
                                    marUsage: res.data.results[0].summary.kWh,
                                    averageKWH: res.data.results[0].summary.kWh + averageKWH
                                });
                                break;
                            case 3:
                                this.setState({
                                    aprUsage: res.data.results[0].summary.kWh,
                                    averageKWH: res.data.results[0].summary.kWh + averageKWH
                                });
                                break;
                            case 4:
                                this.setState({
                                    mayUsage: res.data.results[0].summary.kWh,
                                    averageKWH: res.data.results[0].summary.kWh + averageKWH
                                });
                                break;
                            case 5:
                                this.setState({
                                    junUsage: res.data.results[0].summary.kWh,
                                    averageKWH: res.data.results[0].summary.kWh + averageKWH
                                });
                                break;
                            case 6:
                                this.setState({
                                    julUsage: res.data.results[0].summary.kWh,
                                    averageKWH: res.data.results[0].summary.kWh + averageKWH
                                });
                                break;
                            case 7:
                                this.setState({
                                    augUsage: res.data.results[0].summary.kWh,
                                    averageKWH: res.data.results[0].summary.kWh + averageKWH
                                });
                                break;
                            case 8:
                                this.setState({
                                    sepUsage: res.data.results[0].summary.kWh,
                                    averageKWH: res.data.results[0].summary.kWh + averageKWH
                                });
                                break;
                            case 9:
                                this.setState({
                                    octUsage: res.data.results[0].summary.kWh,
                                    averageKWH: res.data.results[0].summary.kWh + averageKWH
                                });
                                break;
                            case 10:
                                this.setState({
                                    novUsage: res.data.results[0].summary.kWh,
                                    averageKWH: res.data.results[0].summary.kWh + averageKWH
                                });
                                break;
                            case 11:
                                this.setState({
                                    decUsage: res.data.results[0].summary.kWh,
                                    averageKWH: res.data.results[0].summary.kWh + averageKWH
                                });
                                break;
                            default:
                                break;
                        }
                    }

                    this.setState({disableSaveUsage: false});
                })
                .catch(err => console.log('(POST) Error tyring to POST usage: ', err))
        );
    };

    saveUsageOnClick = () => {
        this.setState({disableSaveUsage:true});

        let payload = {
            January_Usage__c: Number(this.state.janUsage),
            January_Bill__c: Number(this.state.janMonBill),
            February_Usage__c: Number(this.state.febUsage),
            February_Bill__c: Number(this.state.febMonBill),
            March_Usage__c: Number(this.state.marUsage),
            March_Bill__c: Number(this.state.marMonBill),
            April_Usage__c: Number(this.state.aprUsage),
            April_Bill__c: Number(this.state.aprMonBill),
            May_Usage__c: Number(this.state.mayUsage),
            May_Bill__c: Number(this.state.mayMonBill),
            June_Usage__c: Number(this.state.junUsage),
            June_Bill__c: Number(this.state.junMonBill),
            July_Usage__c: Number(this.state.julUsage),
            July_Bill__c: Number(this.state.julMonBill),
            August_Usage__c: Number(this.state.augUsage),
            August_Bill__c: Number(this.state.augMonBill),
            September_Usage__c: Number(this.state.sepUsage),
            September_Bill__c: Number(this.state.sepMonBill),
            October_Usage__c: Number(this.state.octUsage),
            October_Bill__c: Number(this.state.octMonBill),
            November_Usage__c: Number(this.state.novUsage),
            November_Bill__c: Number(this.state.novMonBill),
            December_Usage__c: Number(this.state.decUsage),
            December_Bill__c: Number(this.state.decMonBill)
        };

        if(this.state.usageRecord.Id !== '' && this.state.usageRecord.length !== 0){
            payload.Id = this.state.usageRecord.Id;

            axios.put(
                '/sf/usage/update',
                payload,
                {
                    cancelToken: this.source.token
                }).then((res) => {
                    this.getUsage();
                    this.clearEverything();
                })
                .catch(err => console.log('PUT Error updating usage:\n', err))
        } else {
            payload.Lead__c = this.props.match.params.id;
            payload.Name = this.state.lead.Name + ' Usage';

            axios.post(
                '/sf/usage/create',
                payload,
                {
                    cancelToken: this.source.token
                })
                .then((res) => {
                    this.getUsage();
                    this.clearEverything();
                })
                .catch(err => console.log('(POST) Error while trying to create usage:\n', err));
        }
    }

    buildUsagePayload = (data, fromDate, toDate, mId) => {
        let req;

        if(this.state.usageCalcType === 'Usage'){
            req = {
                masterTariffId: mId,
                fromDateTime: fromDate,
                toDateTime: toDate,
                groupBy: 'MONTH',
                propertyInputs: [{
                    fromDateTime: fromDate,
                    toDateTime: toDate,
                    keyName: 'consumption',
                    dataValue: data
                }]
            };
        } else {
            req = {
                fromDateTime: fromDate,
                toDateTime: toDate,
                masterTariffId: mId,
                billingPeriod: "true",
                propertyInputs: [{
                    fromDateTime: fromDate,
                    toDateTime: toDate,
                    keyName: "total",
                    dataValue: data,
                    unit: "cost"
                }, {
                    fromDateTime: fromDate,
                    toDateTime: toDate,
                    keyName: "baselineType",
                    dataValue: "typicalElectricity"
                }]
            };
        }

        return req;
    };

    rateSchedBuilder = (value) => {
        let options = [];

        if(value === 'pge' || value === 'sce'){
            if(value === 'pge'){
                options = [
                    {
                        "id" : "0",
                        "value" : ""
                    },
                    {
                        "id" : "1",
                        "value" : "E1"
                    },
                    {
                        "id" : "2",
                        "value" : "E1 - CARE"
                    },
                    {
                        "id" : "3",
                        "value" : "E1 - CARE & MedBaseline"
                    },
                    {
                        "id" : "4",
                        "value" : "E1 - MedBaseline"
                    },
                    {
                        "id" : "5",
                        "value" : "EL-TOU A CARE"
                    },
                    {
                        "id" : "6",
                        "value" : "EL-TOU B CARE"
                    },
                    {
                        "id" : "7",
                        "value" : "ETOU-A (3-8PM)"
                    },
                    {
                        "id" : "8",
                        "value" : "ETOU-B (4-9PM)"
                    },
                    {
                        "id" : "9",
                        "value" : "EV A"
                    },
                    {
                        "id" : "10",
                        "value" : "EV B"
                    }
                ];
            } else {
                options = [
                    {
                        "id" : "0",
                        "value" : ""
                    },
                    {
                        "id" : "1",
                        "value" : "D"
                    },
                    {
                        "id" : "2",
                        "value" : "D-SDP"
                    },
                    {
                        "id" : "3",
                        "value" : "D-MedBaseline"
                    },
                    {
                        "id" : "4",
                        "value" : "D-CARE"
                    },
                    {
                        "id" : "5",
                        "value" : "D-CARE-SDP"
                    },
                    {
                        "id" : "6",
                        "value" : "D-CARE & MedBaseline"
                    },
                    {
                        "id" : "7",
                        "value" : "D-FERA"
                    },
                    {
                        "id" : "8",
                        "value" : "D-FERA-SDP"
                    },
                    {
                        "id" : "9",
                        "value" : "TOU-D-A"
                    },
                    {
                        "id" : "10",
                        "value" : "TOU-D-A-CARE"
                    },
                    {
                        "id" : "11",
                        "value" : "TOU-D-A-FERA"
                    },
                    {
                        "id" : "12",
                        "value" : "TOU-D-B"
                    },
                    {
                        "id" : "13",
                        "value" : "TOU-D-B-CARE"
                    },
                    {
                        "id" : "14",
                        "value" : "TOU-D-B-FERA"
                    },
                    {
                        "id" : "15",
                        "value" : "TOU-D-T"
                    },
                    {
                        "id" : "16",
                        "value" : "TOU-D-T-CARE"
                    },
                    {
                        "id" : "17",
                        "value" : "TOU-D-T-FERA"
                    },
                    {
                        "id" : "18",
                        "value" : "TOU-D-T Med Baseline"
                    },
                    {
                        "id" : "19",
                        "value" : "TOU-DT-SDP"
                    },
                    {
                        "id" : "20",
                        "value" : "TOU-EV-1"
                    },
                    {
                        "id" : "21",
                        "value" : "TOU-EV-1-CARE"
                    },
                    {
                        "id" : "22",
                        "value" : "TOU-EV-1-FERA"
                    },
                    {
                        "id" : "23",
                        "value" : "TOU-D-4-9PM"
                    },
                    {
                        "id" : "24",
                        "value" : "TOU-D-4-9PM-CARE"
                    },
                    {
                        "id" : "25",
                        "value" : "TOU-D-4-9PM-FERA"
                    },
                    {
                        "id" : "26",
                        "value" : "TOU-D-4-9PM-SDP"
                    },
                    {
                        "id" : "27",
                        "value" : "TOU-D-5-8PM"
                    },
                    {
                        "id" : "28",
                        "value" : "TOU-D-5-8PM-CARE"
                    },
                    {
                        "id" : "29",
                        "value" : "TOU-D-5-8PM-FERA"
                    },
                    {
                        "id" : "30",
                        "value" : "TOU-D-5-8PM-SDP"
                    }
                ];
            }
    
            this.setState({
                utilProvider: value,
                rateOptions: options
            });

        } else {
            if(value === 'avce' || value === 'lce'){
                options = [
                    {
                        "id" : "0",
                        "value" : ""
                    },
                    {
                        "id" : "1",
                        "value" : "D"
                    },
                    {
                        "id" : "2",
                        "value" : "D-CARE"
                    },
                    {
                        "id" : "3",
                        "value" : "TOU-D-4-9PM"
                    },
                    {
                        "id" : "4",
                        "value" : "TOU-D-5-8PM"
                    },
                    {
                        "id" : "5",
                        "value" : "TOU-D-A"
                    },
                    {
                        "id" : "6",
                        "value" : "TOU-D-B"
                    },
                    {
                        "id" : "7",
                        "value" : "TOU-D-T"
                    },
                    {
                        "id" : "8",
                        "value" : "TOU-EV-1"
                    }
                ];
            } else if(value === 'mcece' || value === 'scp'){
                options = [
                    {
                        "id" : "0",
                        "value" : ""
                    },
                    {
                        "id" : "1",
                        "value" : "E1"
                    },
                    {
                        "id" : "2",
                        "value" : "E1 - CARE"
                    },
                    {
                        "id" : "3",
                        "value" : "ETOU-A (3-8PM)"
                    },
                    {
                        "id" : "4",
                        "value" : "ETOU-B (4-9PM)"
                    },
                    {
                        "id" : "5",
                        "value" : "EL-TOU A CARE"
                    },
                    {
                        "id" : "6",
                        "value" : "EL-TOU B CARE"
                    },
                    {
                        "id" : "7",
                        "value" : "E-6/EM-TOU"
                    },
                    {
                        "id" : "8",
                        "value" : "EV A"
                    },
                    {
                        "id" : "8",
                        "value" : "EV B"
                    },
                    {
                        "id" : "8",
                        "value" : "EL-6/EML-TOU CARE"
                    }
                ];
            } else if(value === 'pce' || value === 'pioneerce' || value === 'vce' || value === 'ebce'){
                options = [
                    {
                        "id" : "0",
                        "value" : ""
                    },
                    {
                        "id" : "1",
                        "value" : "E1"
                    },
                    {
                        "id" : "2",
                        "value" : "E1 - CARE"
                    },
                    {
                        "id" : "3",
                        "value" : "ETOU-A (3-8PM)"
                    },
                    {
                        "id" : "4",
                        "value" : "ETOU-B (4-9PM)"
                    },
                    {
                        "id" : "5",
                        "value" : "EL-TOU A CARE"
                    },
                    {
                        "id" : "6",
                        "value" : "EL-TOU B CARE"
                    },
                    {
                        "id" : "7",
                        "value" : "E-6/EM-TOU"
                    },
                    {
                        "id" : "8",
                        "value" : "EV A"
                    },
                    {
                        "id" : "8",
                        "value" : "EV B"
                    }
                ];
            } else if (value === ''){
                if(this.state.utilProvider === 'pge'){
                    options = [
                        {
                            "id" : "0",
                            "value" : ""
                        },
                        {
                            "id" : "1",
                            "value" : "E1"
                        },
                        {
                            "id" : "2",
                            "value" : "E1 - CARE"
                        },
                        {
                            "id" : "3",
                            "value" : "E1 - CARE & MedBaseline"
                        },
                        {
                            "id" : "4",
                            "value" : "E1 - MedBaseline"
                        },
                        {
                            "id" : "5",
                            "value" : "EL-TOU A CARE"
                        },
                        {
                            "id" : "6",
                            "value" : "EL-TOU B CARE"
                        },
                        {
                            "id" : "7",
                            "value" : "ETOU-A (3-8PM)"
                        },
                        {
                            "id" : "8",
                            "value" : "ETOU-B (4-9PM)"
                        },
                        {
                            "id" : "9",
                            "value" : "EV A"
                        },
                        {
                            "id" : "10",
                            "value" : "EV B"
                        }
                    ];
                } else {
                    options = [
                        {
                            "id" : "0",
                            "value" : ""
                        },
                        {
                            "id" : "1",
                            "value" : "D"
                        },
                        {
                            "id" : "2",
                            "value" : "D-SDP"
                        },
                        {
                            "id" : "3",
                            "value" : "D-MedBaseline"
                        },
                        {
                            "id" : "4",
                            "value" : "D-CARE"
                        },
                        {
                            "id" : "5",
                            "value" : "D-CARE-SDP"
                        },
                        {
                            "id" : "6",
                            "value" : "D-CARE & MedBaseline"
                        },
                        {
                            "id" : "7",
                            "value" : "D-FERA"
                        },
                        {
                            "id" : "8",
                            "value" : "D-FERA-SDP"
                        },
                        {
                            "id" : "9",
                            "value" : "TOU-D-A"
                        },
                        {
                            "id" : "10",
                            "value" : "TOU-D-A-CARE"
                        },
                        {
                            "id" : "11",
                            "value" : "TOU-D-A-FERA"
                        },
                        {
                            "id" : "12",
                            "value" : "TOU-D-B"
                        },
                        {
                            "id" : "13",
                            "value" : "TOU-D-B-CARE"
                        },
                        {
                            "id" : "14",
                            "value" : "TOU-D-B-FERA"
                        },
                        {
                            "id" : "15",
                            "value" : "TOU-D-T"
                        },
                        {
                            "id" : "16",
                            "value" : "TOU-D-T-CARE"
                        },
                        {
                            "id" : "17",
                            "value" : "TOU-D-T-FERA"
                        },
                        {
                            "id" : "18",
                            "value" : "TOU-D-T Med Baseline"
                        },
                        {
                            "id" : "19",
                            "value" : "TOU-DT-SDP"
                        },
                        {
                            "id" : "20",
                            "value" : "TOU-EV-1"
                        },
                        {
                            "id" : "21",
                            "value" : "TOU-EV-1-CARE"
                        },
                        {
                            "id" : "22",
                            "value" : "TOU-EV-1-FERA"
                        },
                        {
                            "id" : "23",
                            "value" : "TOU-D-4-9PM"
                        },
                        {
                            "id" : "24",
                            "value" : "TOU-D-4-9PM-CARE"
                        },
                        {
                            "id" : "25",
                            "value" : "TOU-D-4-9PM-FERA"
                        },
                        {
                            "id" : "26",
                            "value" : "TOU-D-4-9PM-SDP"
                        },
                        {
                            "id" : "27",
                            "value" : "TOU-D-5-8PM"
                        },
                        {
                            "id" : "28",
                            "value" : "TOU-D-5-8PM-CARE"
                        },
                        {
                            "id" : "29",
                            "value" : "TOU-D-5-8PM-FERA"
                        },
                        {
                            "id" : "30",
                            "value" : "TOU-D-5-8PM-SDP"
                        }
                    ];
                }
            }

            this.setState({
                utilCCA: value,
                rateOptions: options
            });
        }
    };

    clearAllValues = () => {
        this.setState({
            janUsage: '',
            janMonBill: '',
            febUsage: '',
            febMonBill: '',
            marUsage: '',
            marMonBill: '',
            aprUsage: '',
            aprMonBill: '',
            mayUsage: '',
            mayMonBill: '',
            junUsage: '',
            junMonBill: '',
            julUsage: '',
            julMonBill: '',
            augUsage: '',
            augMonBill: '',
            sepUsage: '',
            sepMonBill: '',
            octUsage: '',
            octMonBill: '',
            novUsage: '',
            novMonBill: '',
            decUsage: '',
            decMonBill: '',
            averageKWH: 0,
            annualTotal: 0,
            calcRan: false,
            disableSaveUsage: true
        })
    };

    clearEverything = () =>{
        this.setState({
            usageModalOpen: false,
            usageCalcType: '',
            utilProvider: '',
            utilCCA: '',
            utilRateSched: '',
            janUsage: '',
            janMonBill: '',
            febUsage: '',
            febMonBill: '',
            marUsage: '',
            marMonBill: '',
            aprUsage: '',
            aprMonBill: '',
            mayUsage: '',
            mayMonBill: '',
            junUsage: '',
            junMonBill: '',
            julUsage: '',
            julMonBill: '',
            augUsage: '',
            augMonBill: '',
            sepUsage: '',
            sepMonBill: '',
            octUsage: '',
            octMonBill: '',
            novUsage: '',
            novMonBill: '',
            decUsage: '',
            decMonBill: '',
            rateOptions: [],
            calcRan: false,
            disableSaveUsage: true
        })
    };

    splitString = (string) => {
        let arrayString = string.split('\n');

        return arrayString;
    };

    checkForAddress = () => {
        if(this.state.lead.Aurora_System_Project_Id__c === null){
            if(this.state.lead.Sales_Representative__c !== null && this.state.lead.Sales_Representative_2__c !== null && this.state.lead.Sales_Rep_1_Setter_Closer__c !== 'Closer' && this.state.lead.Sales_Rep_2_Setter_Closer__c !== 'Closer'){
                this.setState({missingCloserModal: true});
            } else {
                this.setState({checkAddressModal: true});
            }
        } else {
            let auroraURL = "https://v2.aurorasolar.com/projects/" + String(this.state.lead.Aurora_System_Project_Id__c);
            window.open(auroraURL);
        }
    }

    createAuroraSystem = async () => {
        this.setState({
            disableAuroraButton: true,
            checkingAddress: false
        });

        let leadUpdatePayload = {
            Id: this.state.lead.Id
        };

        let ownerEmail = this.state.lead.Sales_Representative_2__c !== null && this.state.lead.Sales_Rep_2_Setter_Closer__c === 'Closer' ? this.state.lead.Sales_Rep_2_Email__c : this.state.lead.Sales_Rep_1_Email__c;

        // Everbright Creation and Logic
        if(this.state.lead.Preferred_Financier__c === 'Everbright' && this.state.lead.Everbright_Site_Id__c === null) {
            const ebPayload = {
                address: { 
                    address_line_1: this.state.lead.Street, 
                    city_name: this.state.lead.City, 
                    state_abbreviation: this.state.lead.State, 
                    zipcode: this.state.lead.PostalCode
                },
                contacts: 
                    [{
                        first_name: this.state.lead.FirstName, 
                        last_name: this.state.lead.LastName, 
                        primary: true
                    }], 
                external_id: this.state.lead.Id,
                external_user_id: ownerEmail
            };

            await axios.post(
                '/everbrightSite',
                ebPayload,
                {
                    cancelToken: this.source.token
                })
                .then((res) => {
                    console.log(res.data)
                    this.setState({evebrightId: String(res.data.uuid)});
                })
                .catch(err => {
                    console.log('(PUT) Error while trying to create Everbright Site: \n', err);
                });
    
            leadUpdatePayload.Everbright_Site_Id__c = this.state.evebrightId;
        }
        
        // Aurora Project Creation and Logic
        if(this.state.lead.Aurora_System_Project_Id__c === null){
            let auroraUser;

            if(this.props.user.role === 'partner'){
                let userEmail = this.props.user.email;
                let splitUser = userEmail.split('@');
                auroraUser = splitUser[0] + '+1@' + splitUser[1];
            } else {
                auroraUser = ownerEmail;
            }

            await axios.get(
                '/auroraProject/' + auroraUser,
                {
                    cancelToken: this.source.token
                })
                .then((res) => {
                    if((res.data.users).length !== 0){
                        this.setState({auroraUserId: res.data.users[0].id});
                    }
                })
                .catch( err => console.log('(GET) Error while getting Aurora User Id:\n', err));
            
            let projName = this.state.lead.Street + ', ' + this.state.lead.City + ', ' + this.state.lead.State + ' ' + this.state.lead.PostalCode + ', USA';

            const payload = {
                project : {
                    external_provider_id: this.state.lead.Id,
                    name: projName,
                    customer_first_name: this.state.lead.FirstName,
                    customer_last_name: this.state.lead.LastName,
                    address: projName,
                    owner_id: this.state.auroraUserId
                }
            };

            await axios.post(
                '/auroraProject',
                payload,
                {
                    cancelToken: this.source.token
                })
                .then((res) => {
                    this.setState({auroraProjectId: String(res.data.project.id)});
                })
                .catch(err => console.log('(POST) Error while trying to create Aurora Project:\n', err));

            
            leadUpdatePayload.Aurora_System_Project_Id__c = this.state.auroraProjectId;

            // Send Consumption if Usage Exists
            if(this.state.usageRecord.length !== 0) {
                const consumptionPayload = {
                    consumption_profile:{
                        monthly_energy: [
                            this.state.usageRecord.January_Usage__c,
                            this.state.usageRecord.February_Usage__c,
                            this.state.usageRecord.March_Usage__c,
                            this.state.usageRecord.April_Usage__c,
                            this.state.usageRecord.May_Usage__c,
                            this.state.usageRecord.June_Usage__c,
                            this.state.usageRecord.July_Usage__c,
                            this.state.usageRecord.August_Usage__c,
                            this.state.usageRecord.September_Usage__c,
                            this.state.usageRecord.October_Usage__c,
                            this.state.usageRecord.November_Usage__c,
                            this.state.usageRecord.December_Usage__c
                        ]
                    }
                };

                axios.put(
                    '/auroraConsumption/' + this.state.auroraProjectId,
                    consumptionPayload,
                    {
                        cancelToken: this.source.token
                    })
                    .then((res) => {
                        console.log(res.data);
                    })
                    .catch(err => {
                        console.log('(PUT) Error while trying to update lead: \n', err);
                    });
            }

            // Open Aurora URL after creating project
            let auroraURL = "https://v2.aurorasolar.com/projects/" + this.state.auroraProjectId;
            window.open(auroraURL);
        }

        await axios.put(
            '/sf/lead/update',
            leadUpdatePayload,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const lead = this.getLead();
                this.setState({creatingAuroraProject: false})
            })
            .catch(err => {
                console.log('(PUT) Error while trying to update lead: \n', err);
            });
    };

    calculatePricing = () => {
        if(this.validPricingCheck()){
            return true;
        } else {
            this.setState({
                kwhError: '',
                ppwError: ''
            });

            let kwh = this.state.kwh;
            let ppw = this.state.ppw;
            let allPricingData = this.state.pricingData;
            let pricingMethod = this.state.pricingMethod;
            let sortingMethod = 'Rate__c';

            if(pricingMethod === 'kwh'){
                sortingMethod= 'Rate__c';
            } else {
                sortingMethod= 'Price_per_Watt__c';
            }

            let findValidValues = _.filter(allPricingData, function(o){
                if(pricingMethod === 'kwh'){
                    return kwh >= o.Rate__c;
                } else {
                    return ppw >= o.Price_per_Watt__c;
                }
            });

            let orderValues = _.orderBy(findValidValues, [sortingMethod], ['desc']);

            if(pricingMethod === 'kwh'){
                let formatPPW = Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(orderValues[0].Price_per_Watt__c);
                let formatKWH = Intl.NumberFormat('en-US', {style:'currency',currency: 'USD', minimumFractionDigits: 3}).format(this.state.kwh);
                let monthlyBill = (this.state.kwh * this.state.prelimProposal.Est_Year_One_Production__c)/ 12;
                this.setState({
                    ppw: orderValues[0].Price_per_Watt__c,
                    displayedPPW: formatPPW,
                    displayedKWH: formatKWH,
                    monthlyBill: monthlyBill
                });
            } else {
                let formatPPW = Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.ppw);
                let formatKWH = Intl.NumberFormat('en-US', {style:'currency',currency: 'USD', minimumFractionDigits: 3}).format(orderValues[0].Rate__c);
                let monthlyBill = (orderValues[0].Rate__c * this.state.prelimProposal.Est_Year_One_Production__c)/ 12;
                this.setState({
                    kwh: orderValues[0].Rate__c.toString(),
                    displayedKWH: formatKWH,
                    displayedPPW: formatPPW,
                    monthlyBill: monthlyBill
                });
            }

            return false;
        }
    };

    savePricing = async () => {
        this.setState({disableSavePricing: true})
        if(this.calculatePricing()){

        } else {
            let payload = {};

            payload = {
                Id: this.state.prelimProposal.Id,
                Price_per_kWh__c: this.state.kwh,
                Price_per_Watt__c: this.state.ppw,
                Escalator__c: '3.50',
                Type__c: 'PPA',
                Financing_Partner__c: 'V3 Electric- In House'
            }

            await axios.put(
                '/sf/proposal/update',
                payload,
                {
                    cancelToken: this.source.token
                }).then((res) => {
                    setTimeout(() => {
                        const prop = this.getProposal(this.state.prelimProposal.Id);
                        this.setState({
                            pricingModalOpen: false,
                            pricingMethod: '',
                            displayedPPW: Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Price_per_Watt__c),
                            displayedKWH: Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Price_per_kWh__c),
                            monthlyBill: this.state.prelimProposal.Monthly_Bill_Amount__c,
                            disableSavePricing: false
                        });
                    }, 
                        15000
                    );
                })
                .catch(err => console.log('PUT Error updating proposal:\n', err))
        }
    };

    validPricingCheck = () => {
        let allPricingData = this.state.pricingData;
        let pricingMethod = this.state.pricingMethod;
        let minValueCheck = _.orderBy(allPricingData, [pricingMethod], ['asc']);

        if(pricingMethod === 'kwh' && (this.state.kwh < 0.13 || this.state.kwh > .35)){
            this.setState({kwhError: 'Not A Valid kWh Rate'});
            return true;
        } else if(pricingMethod === 'ppw' && Number(this.state.ppw) < minValueCheck[0].ppw){
            this.setState({ppwError: 'Not A Valid PPW Rate'});
            return true;
        } else {
            return false;
        }
    };

    calculateCashPricing = () => {
        if(this.state.pricingMethod === 'ppw'){
            let amountCalc = this.state.ppw * (this.state.prelimProposal.System_Size__c * 1000);
            this.setState({
                displayedAmount: Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(amountCalc),
                amount: amountCalc
            });
        } else if(this.state.pricingMethod === 'amount'){
            let ppwCalc = this.state.amount / (this.state.prelimProposal.System_Size__c * 1000);
            this.setState({
                displayedPPW: Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(ppwCalc),
                ppw: ppwCalc
            });
        }
    }

    saveCashPricing = () => {
        this.calculateCashPricing();

        let priceCalcMethod;

        if(this.state.pricingMethod === 'ppw'){
            priceCalcMethod = 'Price per watt';
        } else if(this.state.pricingMethod === 'amount'){
            priceCalcMethod = 'Amount';
        }

        let payload = {
            Id: this.state.prelimProposal.Id,
            Amount__c: this.state.amount,
            Price_per_Watt__c: this.state.ppw,
            Price_Calc_Method__c: priceCalcMethod,
            Monitoring_Maintenance_25_Years__c: this.state.monitorMain
        };

        axios.put(
            '/sf/proposal/update',
            payload,
            {
                cancelToken: this.source.token
            }).then((res) => {
                setTimeout(() => {
                    const prop = this.getProposal(this.state.prelimProposal.Id);
                    this.setState({
                        cashPricingModal: false,
                        pricingMethod: '',
                        displayedPPW: Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Price_per_Watt__c),
                        displayedAmount: Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Amount__c),
                        disableSavePricing: false
                    })
                },
                    7000
                );
            })
            .catch(err => console.log('PUT Error updating proposal:\n', err))        
    }

    convertLead = () => {
        this.setState({leadConvertProcessing: true, leadConvertConfirm: false});

        let leadPayload = {
            Id: this.state.lead.Id,
            Existing_V3_Customer__c: this.state.existingCustomer
        }

        axios.put(
            '/sf/lead/update',
            leadPayload,
            {
                cancelToken: this.source.token
            })
            .then(() => {
                
            })
            .catch(err => console.log('(PUT) Error while trying to update Lead: \n', err));

            
        let payload = {
            Id: this.state.lead.Id
        }

        axios.post(
            '/leadPost',
            payload,
            {
                cancelToken: this.source.token
            }).then((res) => {
                let convertStatus = res.data;
                if(convertStatus.includes('ConvertLead failed')){
                    this.setState({
                        leadConvertFailed: true,
                        leadConvertProcessing: false,
                        leadConvertError: convertStatus
                    });
                } else {
                    this.setState({
                        leadConvertSuccess: true,
                        leadConvertProcessing: false
                    });
                }
            })
            .catch(err => console.log('PUT Error converting lead:\n', err))
    };

    creditCheck = async () => {
        this.setState({runCreditDisabled: true});

        if(this.state.dobCredit === null || this.state.dobCredit === ''){
            this.setState({
                dobCreditError: 'Please Enter Date of Birth',
                runCreditDisabled: false
            })
        } else {
            this.setState({dobCreditError: ''});

            let creditRecordId = this.state.lead.Credit__c;

            // Check if a Credit record exists in SF on the Lead. If no -> create one
            if(!creditRecordId){
                const creditCreatePayload = {
                    Name: this.state.lead.Name + ' Credit',
                    Lead__c: this.state.lead.Id
                };

                try {
                    // doing await, so when we update the credit the creditRecordId is filled in.
                    const { data } = await axios.post(
                        '/sf/credit/create',
                        creditCreatePayload,
                        { cancelToken: this.source.token }
                    );

                    creditRecordId = data.id;
                } catch (err) {
                    console.error('Error creating credit record:', err);
                    this.setState({ runCreditDisabled: false });
                    return;
                }
            }

            let payload = tunaXML(this.state.lead.FirstName, this.state.lead.LastName, 
                this.state.lead.Street, this.state.lead.City, this.state.lead.State, this.state.lead.PostalCode, this.state.dobCredit);
    
            axios.post(
                '/creditCheck',
                payload,
                {
                    cancelToken: this.source.token
                }).then((res) => {
                    const parser = new DOMParser();
                    const xml = parser.parseFromString(res.data, 'text/xml');
                    const errorCheck = xml.getElementsByTagName('error');

                    let creditScore;
                    let creditResult;
                    let lateMortgagePayment = false;
                    let openCollectionAccounts = false;
                    let recentBankruptcy = false;

                    const trades = xml.getElementsByTagName('trade');
                    for(let i = 0; i < trades.length; i++) {
                        const t = trades[i];
                        const type = t.getElementsByTagName('portfolioType')[0]?.textContent;
                        const counters = t.getElementsByTagName('historicalCounters')[0];

                        if(type === 'mortgage' && counters) {
                            const late30 = parseInt(counters.getElementsByTagName('late30DaysTotal')[0]?.textContent || '0', 10);
                            const late60 = parseInt(counters.getElementsByTagName('late60DaysTotal')[0]?.textContent || '0', 10);
                            const late90 = parseInt(counters.getElementsByTagName('late90DaysTotal')[0]?.textContent || '0', 10);

                            if (late30 > 0 || late60 > 0 || late90 > 0) {
                                lateMortgagePayment = true;
                                break;
                            }
                        }
                    }

                    const collections = xml.getElementsByTagName('collection');
                    for(let i = 0; i < collections.length; i++) {
                        const col = collections[i];
                        const hasPaid = col.getElementsByTagName('datePaid').length > 0 && col.getElementsByTagName('datePaid')[0].textContent.trim() !== '';
                        const hasClosed = col.getElementsByTagName('dateClosed').length > 0 && col.getElementsByTagName('dateClosed')[0].textContent.trim() !== '';

                        if(!hasPaid && !hasClosed) {
                            openCollectionAccounts = true;
                            break;
                        }
                    }

                    const publicRecords = xml.getElementsByTagName('publicRecord');
                    const now = new Date();
                    const sevenYearsAgo = new Date();
                    sevenYearsAgo.setFullYear(now.getFullYear() - 7);
                    
                    for(let i = 0; i < publicRecords.length; i++) {
                        const pr = publicRecords[i];
                        const prType = pr.getElementsByTagName('type')[0]?.textContent;

                        // Checking if it is a bankruptcy public record
                        if(prType === 'Chapter 13 bankruptcy filing' || prType === 'Chapter 13 bankruptcy discharged') {
                            const hasPaid = pr.getElementsByTagName('datePaid').length > 0 && pr.getElementsByTagName('datePaid')[0].textContent.trim() !== '';

                            // Check if the found bankruptcy doesn't have paid date
                            if(!hasPaid) {
                                recentBankruptcy = true;
                                break;
                            }

                            // Check if the found bankruptcy does have a paid date, but 7 years haven't passed since.
                            const paidDate = new Date(pr.getElementsByTagName('datePaid')[0].textContent);
                            if(paidDate > sevenYearsAgo) {
                                recentBankruptcy = true;
                                break;
                            }
                        }
                    }

                    if(errorCheck.length !== 0){
                        this.setState({
                            creditAPIError: xml.getElementsByTagName('description')[0].innerHTML,
                            creditCheckFailed: true,
                            runCreditDisabled: false
                        })
                    } else if (xml.getElementsByTagName('fileHitIndicator')[0].innerHTML === 'regularNoHit') {
                        this.setState({creditResult: 'No Hit'})
                    } else {
                        let creditString = xml.getElementsByTagName('results')[0].innerHTML;
                        creditScore = parseInt(creditString.slice(1));

                        if(creditScore >= 680 && !lateMortgagePayment && !openCollectionAccounts && !recentBankruptcy){
                            creditResult = 'Pass';
                        } else if(creditScore >= 650 && !lateMortgagePayment){
                            creditResult = 'Manual Review';
                        } else {
                            creditResult = 'Fail';
                        }

                        this.setState({creditScore: creditScore});
                        this.setState({creditResult: creditResult});
                    }

                    if(creditResult !== null || creditResult !== ''){
                        const creditUpdatePayload = {
                            Id: creditRecordId,
                            Date_of_Birth__c: this.state.dobCredit,
                            In_House_Credit_Status__c: creditResult,
                            Credit_Score__c: creditScore,
                            Late_Mortgage_Payments__c: lateMortgagePayment,
                            Open_Collection_Accounts__c: openCollectionAccounts,
                            Recent_Bankruptcy__c: recentBankruptcy
                        };
                
                        axios.put(
                            '/sf/credit/update',
                            creditUpdatePayload,
                            {
                                cancelToken: this.source.token
                            })
                            .then((res) => {
                                console.log(res.data);
                                setTimeout(() => this.setState({runCreditDisabled: false}), 5000);
                            })
                            .catch(err => {
                                console.log('(PUT) Error while trying to update lead: \n', err);
                                setTimeout(() => this.setState({runCreditDisabled: false}), 5000);
                            });
                        
                        if(this.state.creditResult !== 'No Hit'){
                            let encodedStringAtoB = xml.getElementsByTagName('embeddedData')[0].innerHTML;
                            let pdfText = atob(encodedStringAtoB);
                            const length = pdfText.length;
                            const arrayBuffer = new ArrayBuffer(length);
                            const uintArray = new Uint8Array(arrayBuffer);
                            for (let i = 0; i < length; i++) {
                                uintArray[i] = pdfText.charCodeAt(i);
                            }
                            let creditName = this.state.lead.Name + ' Credit Report.pdf';
                            let pdfDecode = new File ([uintArray], creditName, {type: 'application/pdf'});

                            const data = new FormData();
                            data.append('file', pdfDecode);

                            // Delaying call to attach PDF to give time for the credit record to be created if it needs to be
                            setTimeout(() => this.attachCreditPDF(data, creditRecordId), 5000);
                        }
                    }
                })
                .catch(err => console.log('POST Error running credit check:\n', err))
        }
    };

    attachCreditPDF = (data, creditRecordId) => {
        axios.post(
            `/sf/attachment/upload/` + creditRecordId,
            data,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                
            })
            .catch(err => {
                console.log('POST Error attaching PDF:\n', err)
            });
    };

    titleCheck = () => {
        this.setState({titleCheckButtonDisabled: true});
        let addressString = this.state.lead.Street + ' ' + this.state.lead.City + ' ' + this.state.lead.State + ' ' + this.state.lead.PostalCode;

        let payload = {
            "ProductNames": [
                "PropertyDetailReport"
            ],
            "SearchType": "FullAddress",
            "FullAddress": addressString,
            "ReferenceId": "V3 ELECTRIC LLC"
        };

        axios.post(
            '/titleCheck',
            payload,
            {
                cancelToken: this.source.token
            }).then((res) => {
                if(res.data.ErrorList != null){
                    this.setState({titleCheckResult: res.data.Message});
                } else if(res.data.MaxResultsCount > 1){
                    this.setState({titleCheckResult: 'Multiple Hits'});
                } else {
                    this.setState({
                        titleCheckResult: 'Success',
                        primaryTitle: res.data.Reports[0].Data.OwnerInformation.Owner1FullName,
                        secondaryTitle: res.data.Reports[0].Data.OwnerInformation.Owner2FullName,
                        homeType: res.data.Reports[0].Data.SiteInformation.LandUse
                    });

                    const leadUpdatePayload = {
                        Id: this.state.lead.Id,
                        Home_Type_on_Title__c: this.state.homeType,
                        Primary_Title__c: this.state.primaryTitle,
                        Secondary_Title__c: this.state.secondaryTitle
                    }

                    axios.put(
                        '/sf/lead/update',
                        leadUpdatePayload,
                        {
                            cancelToken: this.source.token
                        })
                        .then((res) => {
                            setTimeout(() => this.setState({titleCheckButtonDisabled: false}), 5000);
                        })
                        .catch(err => {
                            console.log('(PUT) Error while trying to update lead: \n', err);
                            setTimeout(() => this.setState({titleCheckButtonDisabled: false}), 5000);
                        });
                }
            })
            .catch(err => {
                console.log('PUT Error running Title Check:\n', err);
                this.setState({titleCheckButtonDisabled: false, titleCheckResult: 'Error Running Title Check'});
            })
    };

    saveLeadNotes = () => {
        this.setState({leadNotesDisabled: true});

        const payload = {
            Id: this.state.lead.Id,
            Sales_Notes__c: this.state.leadNotes
        };

        axios.put(
            '/sf/lead/update',
            payload,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const lead = this.getLead();
                this.setState({leadNotesDisabled: false, leadNoteSaveSuccess: true});
                setTimeout(() => this.setState({leadNoteSaveSuccess: false}), 5000);
            })
            .catch(err => {
                console.log('(PUT) Error while trying to update lead: \n', err);
                this.setState({leadNotesDisabled: false});
            });
    };

    getRepContactForDocs = (docType) => {
        this.setState({sendAgreementDisabled: true, agreementConfirm: true, cpucConfirm: true});

        let contactUrl = '/sf/contact/findOne/' + this.state.repIdForContract;

        axios.get(
            contactUrl,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({repContactForDocs: res.data})
                if(docType === 'cpuc') {
                    this.createCPUC();
                } else {
                    this.createContract();
                }
            })
            .catch(err => console.log('(GET) Error tyring to fetch rep contact: ', err));
    };

    createContract = () => {
        let payload = {
            PrelimId: this.state.lead.Active_Prelim_Proposal__c,
            RepId: this.state.repIdForContract,
            TypeOfLead: 'Contract'
        };

        axios.post(
            '/leadPost',
            payload,
            {
                cancelToken: this.source.token
            }).then((res) => {
                let contractRes = res.data;
                
                setTimeout(() => {
                    this.setState({createdContract: 'green'});
                    this.getNewContract(contractRes);
                }, 3000);
            })
            .catch(err => {
                this.setState({createdContract: 'red'});
                console.log('PUT Error creating contract:\n', err)
            });
    };

    getNewContract = (cId) => {
        let contractUrl = '/sf/contractNew/findOne/' + cId;
        
        axios.get(
            contractUrl,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data;
                this.setState({
                    newContract: data,
                    createdDoc: 'green'
                });

                // Old method of creating Panda Docs
                // A new method of creating them via Salesforce was created
                // That we leverage using the Portal Webhook
                // this.createPandaDocAgreement();

                let payload = {
                    ContractId: this.state.newContract.Id,
                    Confirm: true,
                    TypeOfLead: 'SendContract'
                };
        
                axios.post(
                    '/leadPost',
                    payload,
                    {
                        cancelToken: this.source.token
                    }).then((res) => {
                        this.setState({docStatus: 'green'});
                        setTimeout(() => {
                            this.setState({sentDoc: 'green'});
                        }, 7000);
                    })
                    .catch(err => {
                        this.setState({docStatus: 'red'});
                        console.log('PUT Error sending contract from salesforce:\n', err)
                    });
            })
            .catch(err => {
                this.setState({createdDoc: 'red'});
                console.log('(GET) Error tyring to fetch lead records: ', err);
            });
    };

    createPandaDocAgreement = () => {
        let payload = {};
        if(this.state.prelimProposal.Battery_Type__c === null){
            payload = {...getPandaDocFields(this.state.newContract, this.state.lead, this.state.repContactForDocs)};
        } else {
            payload = {...getPandaDocFieldsBattery(this.state.newContract, this.state.lead, this.state.repContactForDocs)};
        }

        axios.post(
            '/pandaDoc/create/v3',
            payload,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                let docId = res.data.id;

                this.setState({createdDoc: 'green'})

                let linkPayload = {
                    "provider": "salesforce-oauth2",
                    "entity_type": "contract__c",
                    "entity_id": this.state.newContract.Id
                };

                setTimeout(() => {
                    this.linkDocument(docId, linkPayload);
                }, 7000);
            })
            .catch(err => {
                this.setState({createdDoc: 'red'})
                console.log('(POST) Error while trying to create PandaDoc agreement:\n', err);
            });
    };

    // Method to create the CPUC PandaDoc Document
    createCPUC = () => {
        let payload = {
            "recipients":
                [
                    {  
                        "email": this.state.repContactForDocs.Email,
                        "first_name": this.state.repContactForDocs.FirstName,
                        "last_name": this.state.repContactForDocs.LastName,
                        "role": "Sales Rep"
                    },
                    {
                        "email": this.state.lead.Email,
                        "first_name":this.state.lead.FirstName,
                        "last_name":this.state.lead.LastName,
                        "role": "Homeowner"
                    }
                ],
            "name": this.state.lead.Name + " CPUC",
            "template_uuid":"XK5VRwYLqPJQ7QYQtABMUU",
            "tokens": 
                [
                    {
                        "name": "Contact__r.Name",
                        "value": this.state.lead.Name
                    },
                    {
                        "name": "Sales Rep.FirstName",
                        "value": this.state.repContactForDocs.FirstName
                    },
                    {
                        "name": "Sales Rep.LastName",
                        "value": this.state.repContactForDocs.LastName
                    }
                ]
        };

        axios.post(
            '/pandaDoc/create/v3',
            payload,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                let docId = res.data.id;

                this.setState({createdDoc: 'green'})

                let linkPayload = {
                    "provider": "salesforce-oauth2",
                    "entity_type": "lead",
                    "entity_id": this.state.lead.Id
                };

                setTimeout(() => {
                    this.linkDocument(docId, linkPayload);
                }, 7000);
            })
            .catch(err => {
                this.setState({createdDoc: 'red'})
                console.log('(POST) Error while trying to create PandaDoc CPUC:\n', err);
            });

        let leadPayload = {
            Id: this.state.lead.Id,
            CPUC_Sent__c: moment().format('yyyy-MM-DD')
        };

        axios.put(
            '/sf/lead/update',
            leadPayload,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                
            })
            .catch(err => {
                console.log('(PUT) Error while trying to update CPUC Sent on lead: \n', err);
                this.setState({leadNotesDisabled: false});
            });
    };

    linkDocument = (id, linkPayload) => {
        let requestString = '/pandaDoc/getStatus/v3/' + id;

        axios.get(
            requestString,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                let docStatus = res.data.status;

                if(docStatus === 'document.draft'){
                    this.setState({docStatus: 'green'});

                    axios.post(
                        '/pandaDoc/link/v3/' + id,
                        linkPayload,
                        {
                            cancelToken: this.source.token
                        })
                        .then((res) => {
                            setTimeout(() => {
                                this.sendAgreement(id);
                            }, 3000);
                        })
                        .catch(err => {
                            this.setState({sentDoc: 'red'});
                            console.log('(POST) Error while trying to send agreement:\n', err);
                        });
                } else {
                    this.setState({docStatus: 'red'});
                }
            })
            .catch(err => {
                this.setState({docStatus: 'red'});
                console.log('(POST) Error while trying to get document status:\n', err);
            });
    };

    // Method to Send PandaDock Documents and Link to the Salesforce Object
    sendAgreement = (id) => {
        axios.post(
            '/pandaDoc/send/v3/' + id,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({sentDoc: 'green'});
            })
            .catch(err => {
                this.setState({sentDoc: 'red'});
                console.log('(POST) Error while trying to send agreement:\n', err);
            });
    };

    render() {
        return (
            <div className={css.LeadDetails}>
                {/* ---------- header info: ---------- */}
                <div className="row">
                    {/* ----- row 1: ----- */}
                    <div className="col-12 col-md-4 mb-2">
                        <h4>name</h4>
                        <h1>{this.state.lead.Name}</h1>
                    </div>
                    <div className="col-12 col-md-4 mb-2">
                        <h4>created date</h4>
                        <h1>{moment(this.state.lead.CreatedDate).format('MMM D, YYYY')}</h1>
                    </div>
                    <div className="col-12 col-md-4 mb-2">
                        <h4>status</h4>
                        <h1>{this.state.lead.Status__c}</h1>
                    </div>

                    {/* ----- row 2: ----- */}
                    <div className="col-12 col-md-4 mb-2">
                        <h4>size</h4>
                        <h1>{this.state.lead.System_Size__c}</h1>
                    </div>

                    <div className="col-12 col-md-4 mb-2">
                        <h4>kWh Price</h4>
                        <h1>{Intl.NumberFormat('en-US', {style:'currency',currency: 'USD', minimumFractionDigits: 3}).format(this.state.lead.Starting_kWh_Price__c)}</h1>
                    </div>
                    <div className="col-12 col-md-4 mb-2">
                        <h4>Module</h4>
                        <h1>{this.state.lead.Module_Type__c}</h1>
                    </div>
                </div>

                {/* ---------- main section: ---------- */}
                <div className={`${css.LeadDetails__Main} mt-3`}>

                    {/* ----- CTA Buttons: ---- */}
                    <div className="text-center d-flex flex-column d-sm-block">
                        {
                            this.state.isEditingLead ?
                                (
                                    <>
                                        <button className="btn btn-primary" type="button" onClick={() => this.toggleEditLead(false)}>cancel</button>
                                        <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0" type="button" onClick={() => this.saveLeadOnClick()}>save</button>
                                    </>
                                )
                                :
                                ( <button className="btn btn-primary" type="button" onClick={() => this.toggleEditLead(true)}>edit lead</button> )
                        }

                        <Link to={`/attachment/${this.leadId}/${this.state.lead.Name}`}>
                            <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0 w-100 w-sm-auto"><FontAwesomeIcon icon={faPlus} /> attachments</button>
                        </Link>
                        {/* <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0" onClick={() => this.setState({isModelOpen: true})}>log attempt</button> */}
                        <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0 w-100 w-sm-auto" onClick={() => this.setState({titleCheckModal: true})}>Title Check</button>
                        <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0 w-100 w-sm-auto" onClick={() => this.setState({creditCheckModal: true})}>Credit Check</button>
                        <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0 w-100 w-sm-auto" onClick={() => this.setState({leadConvertModalIsOpen: true})}>Convert Lead</button>
                        <div className="d-none d-sm-block"><br/></div>
                        <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0 w-100 w-sm-auto" onClick={() => this.setState({usageModalOpen: true})}>Usage/Bill</button>
                        <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0 w-100 w-sm-auto" disabled={this.state.disableAuroraButton} onClick={this.checkForAddress}>Create Design</button>
                        <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0 w-100 w-sm-auto" disabled={this.state.disablePricingButton} onClick={() => 
                            this.state.lead.Preferred_Financier__c === 'Everbright' ? window.open('https://engine.goeverbright.com/project/' + this.state.lead.Everbright_Site_Id__c) :
                            this.state.lead.Preferred_Financier__c === 'LightReach' ? window.open('https://sabal.palmetto.com/accounts/' + this.state.lead.LightReach_Account_Id__c) :
                            this.state.prelimProposal.Type__c === 'Purchase' && this.state.prelimProposal.Financing_Partner__c === 'Cash' ? this.setState({cashPricingModal: true}) : this.setState({pricingModalOpen: true})}>Pricing</button>
                        <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0" onClick={() => this.setState({cpucModalIsOpen: true})}>Send CPUC</button>
                        <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0 w-100 w-sm-auto" disabled={((this.state.lead.CPUC_Sent__c === null && this.state.lead.State !== 'TX') || this.state.lead.Preferred_Financier__c !== 'V3 Electric- In House') ? true : false} onClick={() => this.setState({agreementProcessModal: true})}>Send Agreement</button>
                    </div>

                    <div className="row pt-2">
                        <div className="col-12 col-md-8">

                            {/* ---------- Edit Mode: ---------- */}
                            <div className={this.state.isEditingLead ? 'mt-2' : 'd-none'}>
                                {/* the attribute `enableReinitialize` ensures that the initial values updates once state is fetched/updated: */}
                                <Formik
                                    enableReinitialize

                                    innerRef={this.refEditLead}

                                    // we need to set initial values while the state is still undefined (being fetched), so we set it to empty string
                                    // (if we don't do this, we get an error about a component changing an uncontrolled input to be controlled):
                                    initialValues={{
                                        firstName: this.state.lead.FirstName || '',
                                        middleName: this.state.lead.MiddleName || '',
                                        lastName: this.state.lead.LastName || '',
                                        street: this.state.lead.Street || '',
                                        city: this.state.lead.City || '',
                                        state: this.state.lead.State || '',
                                        zip: this.state.lead.PostalCode || '',
                                        leadStatus: this.state.lead.Status__c || '',
                                        email: this.state.lead.Email || '',
                                        phone: this.state.lead.Phone || '',
                                        leadPurpose: this.state.lead.Lead_Purpose__c || '',
                                        utilityProvider: this.state.lead.Utility__c || '',
                                        titleNameCredit: this.state.lead.Title_Name_for_Credit__c || '',
                                        battery: this.state.prelimProposal.Battery_Type__c || '',
                                        numOfBatteries: this.state.prelimProposal.Number_of_Batteries__c || '',
                                        baterryCommission: this.state.prelimProposal.Battery_Commission__c || '',
                                        preferredFinancier: this.state.lead.Preferred_Financier__c || '',
                                        setter1: this.state.lead.Sales_Rep_1_Setter_Closer__c || '',
                                        setter2: this.state.lead.Sales_Rep_2_Setter_Closer__c || '',
                                        customerType: this.state.lead.Customer_Type__c?.split(';') || []
                                    }}

                                    validate={(values) => {
                                        const errors = {};

                                        if(values.numOfBatteries !== '' && values.numOfBatteries > 4){
                                            errors.numOfBatteries = 'Please confirm number of batteries';
                                        }

                                        if((values.battery === '' && values.numOfBatteries !== '') || (values.battery !== '' && values.numOfBatteries === '')){
                                            errors.battery = 'Both Battery and Number of Batteries need to be entered if adding or cleared if removing';
                                        }

                                        return errors;
                                    }}

                                    onSubmit={(values) => {
                                        // n.b. for `Prelim_Appointment_Time__c`, the date picker returns an array, so we subscript the first element
                                        let payload = {
                                            Id: this.leadId,
                                            FirstName: values.firstName,
                                            MiddleName: values.middleName,
                                            LastName: values.lastName,
                                            Status__c: values.leadStatus,
                                            Street: values.street,
                                            City: values.city,
                                            State: values.state,
                                            PostalCode: values.zip,
                                            Email: values.email,
                                            Phone: values.phone,
                                            Prelim_Appointment_Time__c: this.state.prelimAppointmentTime[0],
                                            Sat__c: this.state.satTime[0],
                                            Lead_Purpose__c: values.leadPurpose,
                                            Utility__c: values.utilityProvider,
                                            Title_Name_for_Credit__c: values.titleNameCredit,
                                            Preferred_Financier__c: values.preferredFinancier,
                                            Sales_Rep_1_Setter_Closer__c: values.setter1,
                                            Sales_Rep_2_Setter_Closer__c: values.setter2,
                                            Customer_Type__c: values.customerType.join(';')
                                        };

                                        if(this.state.selectedRep !== ''){
                                            if(this.state.selectedRep === 'Remove'){
                                                payload.Sales_Representative_2__c = '';
                                            } else {
                                                payload.Sales_Representative_2__c = this.state.selectedRep;
                                            }
                                        }

                                        if(values.titleNameCredit === 'Primary') {
                                            let primaryName = this.state.lead.Primary_Title__c.split(' ');
                                            
                                            if(primaryName.length > 2){
                                                if(this.state.lead.Name !== primaryName[2] + ' ' + primaryName[1]){
                                                    payload.FirstName = primaryName[2];
                                                    payload.LastName = primaryName[1];
                                                }
                                                payload.Company = primaryName[2] + ' ' + primaryName[1];
                                            } else {
                                                if(this.state.lead.Name !== primaryName[1] + ' ' + primaryName[0]){
                                                    payload.FirstName = primaryName[1];
                                                    payload.LastName = primaryName[0];
                                                }
                                                payload.Company = primaryName[1] + ' ' + primaryName[0];
                                            }
                                        } else if(values.titleNameCredit === 'Secondary') {
                                            let secondaryName = this.state.lead.Secondary_Title__c.split(' ');
            
                                            if(secondaryName.length > 2){
                                                if(this.state.lead.Name !== secondaryName[2] + ' ' + secondaryName[1]){
                                                    payload.FirstName = secondaryName[2];
                                                    payload.LastName = secondaryName[1];
                                                }
                                                payload.Company = secondaryName[2] + ' ' + secondaryName[1];
                                            } else {
                                                if(this.state.lead.Name !== secondaryName[1] + ' ' + secondaryName[0]){
                                                    payload.FirstName = secondaryName[1];
                                                    payload.LastName = secondaryName[0];
                                                }
                                                payload.Company = secondaryName[1] + ' ' + secondaryName[0];
                                            }
                                        }

                                        if(this.state.prelimProposal !== null && Object.keys(this.state.prelimProposal).length !== 0){
                                            let battery = values.battery; 
                                            let numBatteries = values.numOfBatteries;

                                            if(battery === ''){
                                                battery = null
                                            }
                                            if(numBatteries === 0 || numBatteries === ''){
                                                numBatteries = null;
                                            }

                                            const propPayload = {
                                                Id: this.state.prelimProposal.Id,
                                                Number_of_Batteries__c: numBatteries,
                                                Battery_Type__c: battery,
                                                Battery_Commission__c: values.baterryCommission
                                            }

                                            if(battery === 'a0E6O00000pTTGzUAO') {
                                                propPayload.Monthly_Battery_Amount__c = '';
                                            }

                                            axios.put(
                                                '/sf/proposal/update',
                                                propPayload,
                                                {
                                                    cancelToken: this.source.token
                                                })
                                                .then(() => {
                                                    // fetch updated records and close 'edit mode':
                                                    const prop = this.getProposal(this.state.lead.Active_Prelim_Proposal__c);
                                                })
                                                .catch(err => console.log('(PUT) Error while trying to update proposal: \n', err));
                                        }

                                        axios.put(
                                            '/sf/lead/update',
                                            payload,
                                            {
                                                cancelToken: this.source.token
                                            })
                                            .then(() => {
                                                // fetch updated records and close 'edit mode':
                                                const lead = this.getLead();
                                                this.getActiveReps(lead.Sales_Representative__c, lead.Sales_Representative_2__c);
                                            })
                                            .catch(err => console.log('(PUT) Error while trying to update Lead: \n', err));
                                    }}
                                >
                                    <Form>
                                        <div className="row py-2 text-md">
                                            <div className="col-12 col-sm-4"><h6>Rep 1</h6>
                                                <div>{this.state.firstRep}</div>
                                                <div className="font-weight-bold pt-2">
                                                    <Field as="select" name="setter1">
                                                        <option value="">None</option>
                                                        <option value="Setter">Setter</option>
                                                        <option value="Closer">Closer</option>
                                                    </Field>
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-4"><h6>Rep 2</h6>
                                                <Downshift 
                                                    onChange={selection => this.setState({selectedRep: selection.id})}
                                                    itemToString={item => (item ? item.value : '')}
                                                >
                                                    {({
                                                        getInputProps,
                                                        getItemProps,
                                                        getLabelProps,
                                                        getMenuProps,
                                                        isOpen,
                                                        inputValue,
                                                        highlightedIndex,
                                                        selectedItem,
                                                        getToggleButtonProps
                                                    }) => (
                                                    <div>
                                                        <div className="w-72 flex flex-col gap-1">
                                                            <div className="flex bg-white gap-0.5">
                                                                <input className='form-control' placeholder="Type Rep Name" {...getInputProps()} />
                                                            </div>
                                                        </div>
                                                        <ul className="list-group" {...getMenuProps()}>
                                                            {
                                                                isOpen ? 
                                                                this.state.items.filter(item => !inputValue || (item.value).toLowerCase().includes(inputValue) || item.value.includes(inputValue))
                                                                    .map((item, index) => (
                                                                    <li className="list-group-item" {...getItemProps({key: item.value, index, item,
                                                                        style: {
                                                                            backgroundColor:
                                                                            highlightedIndex === index ? 'lightgray' : 'white',
                                                                            fontWeight: selectedItem === item ? 'bold' : 'normal',
                                                                        },
                                                                        })}
                                                                    >
                                                                        {item.value}
                                                                    </li>
                                                                ))
                                                                : null
                                                            }
                                                        </ul>
                                                    </div>
                                                    )}
                                                </Downshift>
                                                <div className="font-weight-bold pt-2">
                                                    <Field as="select" name="setter2">
                                                        <option value="">None</option>
                                                        <option value="Setter">Setter</option>
                                                        <option value="Closer">Closer</option>
                                                    </Field>
                                                </div>
                                            </div>
                                        </div>
                                        <h2>Lead Details</h2>

                                        <table>
                                            <tbody>
                                            <tr className="col-md-6">
                                                <td className="w-50">First Name</td>
                                                <td className="w-50 font-weight-bold">
                                                    {this.state.leadNameEditDisabled ?
                                                        <>{this.state.lead.FirstName}</>
                                                        :
                                                        <Field className="input input-plain" name="firstName" type="text"></Field>
                                                    }
                                                </td>
                                            </tr>
                                            {/* Show middle name only if one exists. Needed just for rare examples. */}
                                            {this.state.lead.MiddleName && <>
                                            <tr className="col-md-6">
                                                <td className="w-50">Middle Name</td>
                                                <td className="w-50 font-weight-bold">
                                                    {this.state.leadNameEditDisabled ?
                                                        <>{this.state.lead.MiddleName}</>
                                                        :
                                                        <Field className="input input-plain" name="middleName" type="text"></Field>
                                                    }
                                                </td>
                                                </tr>
                                            </>}
                                            <tr className="col-md-6">
                                                <td className="w-50">Last Name</td>
                                                <td className="w-50 font-weight-bold">
                                                    {this.state.leadNameEditDisabled ?
                                                        <>{this.state.lead.LastName}</>
                                                        : 
                                                        <Field className="input input-plain" name="lastName" type="text"></Field>
                                                    }
                                                </td>
                                            </tr>
                                            <tr className="col-md-6">
                                                <td className="w-50">Lead Status</td>
                                                <td className="w-50 font-weight-bold">
                                                    <Field name="leadStatus" as="select">
                                                        { this.leadStatusOptions.map(option => <option key={option} value={option}>{option}</option>) }
                                                    </Field>
                                                </td>
                                            </tr>
                                            <tr className="col-md-6">
                                                <td className="w-50">Preferred Financier</td>
                                                <td className="w-50 font-weight-bold">
                                                    <Field as="select" name="preferredFinancier">
                                                        <option value="" hidden disabled></option>
                                                        <option value="Cash">Cash</option>
                                                        {/* <option value="V3 Electric- In House">V3 Electric- In House</option> */}
                                                        <option value="Mosaic">Mosaic</option>
                                                        <option value="SunRun">SunRun</option>
                                                        <option value="Goodleap">Goodleap</option>
                                                        <option value="Everbright">Everbright</option>
                                                        <option value="LightReach">LightReach</option>
                                                        <option value="Enfin">Enfin</option>
                                                        <option value="Thrive">Thrive</option>
                                                        <option value="Solrite">Solrite</option>
                                                        {/* { this.state.optionsPreferredFinancier.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) } */}
                                                    </Field>
                                                </td>
                                            </tr>
                                            <tr className="mt-3 mt-md-0">
                                                <td className="w-50">Prelim Appt Time</td>
                                                <td className="w-50 font-weight-bold">
                                                    {/* n.b. we have to manually manage state (rather than having Formik doing it for us): */}
                                                    <Flatpickr
                                                            options={{
                                                                enableTime: true,
                                                                dateFormat: 'n/j/Y h:iK'
                                                            }}
                                                            value={this.state.prelimAppointmentTime}
                                                            onChange={date => {
                                                                this.setState({ prelimAppointmentTime: date });
                                                            }}
                                                    />
                                                </td>
                                            </tr>
                                            
                                            <tr className="col-md-6 mt-3 mt-md-0">
                                                <td className="w-50">Qualified Sit</td>
                                                <td className="w-50 font-weight-bold">
                                                    {/* The Qualified Sit date can be only changed by closers when it is blank */}
                                                    {this.state.isUserCloser && !this.state.lead.Sat__c ? 
                                                        <Flatpickr
                                                            value={this.state.lead.Sat__c}
                                                            onChange={date => {
                                                                this.setState({ satTime: date });
                                                            }}
                                                        />
                                                    :
                                                        <>{this.state.lead.Sat__c ? formatShortDate(this.state.lead.Sat__c) : "---"}</>
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="w-50">Primary Title</td>
                                                <td className="w-50 font-weight-bold">{this.state.lead.Primary_Title__c ? this.state.lead.Primary_Title__c : "---"}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-50">Secondary Title</td>
                                                <td className="w-50 font-weight-bold">{this.state.lead.Secondary_Title__c ? this.state.lead.Secondary_Title__c : "---"}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-50">Title Name for Credit</td>
                                                <td className="w-50 font-weight-bold">
                                                    <Field name="titleNameCredit" as="select">
                                                        <option value="" hidden disabled></option>
                                                        <option key="Primary" value="Primary">Primary</option>
                                                        <option key="Secondary" value="Secondary">Secondary</option>
                                                    </Field>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="w-50">Contract Status</td>
                                                <td className="w-50 font-weight-bold">{this.state.prelimProposal.Contract_New__r ? this.state.prelimProposal.Contract_New__r.Status__c : '---'}</td>
                                            </tr>
                                            <tr className="col-md-6">
                                                <td className="w-50">Customer Type</td>
                                                <td className="w-50 font-weight-bold">
                                                    <Field as="select" name="customerType" multiple={true} style={{ height: "100px" }}>
                                                        { this.state.optionsCustomerType.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                                                    </Field>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>

                                        {/* ----- System Details: ----- */}
                                        <h2 className='pt-2'>System Details</h2>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td className="w-50">System Size</td>
                                                <td className="w-50 font-weight-bold">{this.state.prelimProposal.System_Size__c ? this.state.prelimProposal.System_Size__c : "---"}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-50">EPC</td>
                                                <td className="w-50 font-weight-bold">{this.state.prelimProposal.EPC__c ? (this.state.prelimProposal.EPC__c).toFixed(2) : "---"}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-50">kWh</td>
                                                <td className="w-50 font-weight-bold">{this.state.prelimProposal.Price_per_kWh__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD', minimumFractionDigits: 3}).format(this.state.prelimProposal.Price_per_kWh__c) : "---"}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-50">Price Per Watt</td>
                                                <td className="w-50 font-weight-bold">{this.state.prelimProposal.Price_per_Watt__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Price_per_Watt__c) : "---"}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-50">Amount</td>
                                                <td className="w-50 font-weight-bold">{this.state.prelimProposal.Price_per_Watt__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Amount__c) : "---"}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-50">Annual Production</td>
                                                <td className="w-50 font-weight-bold">{this.state.prelimProposal.Est_Year_One_Production__c ? this.state.prelimProposal.Est_Year_One_Production__c.toLocaleString(undefined, {maximumFractionDigits:0}) : "---"}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-50">Annual Usage</td>
                                                <td className="w-50 font-weight-bold">{this.state.prelimProposal.Annual_Usage__c ? this.state.prelimProposal.Annual_Usage__c.toLocaleString(undefined, {maximumFractionDigits:0}) : "---"}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-50">Utility Provider</td>
                                                <td>
                                                    <Field name="utilityProvider" as="select">
                                                    <option value="" hidden disabled></option>
                                                    {/* { this.state.optionsUtilityProvider.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) } */}
                                                    { this.state.availableUtilityProviders.map((option) => <option key={option.id} value={option.id}>{option.value}</option>) }
                                                    </Field>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="w-50">Battery</td>
                                                <td>
                                                    <Field name="battery" as="select">
                                                    <option value=""></option>
                                                    <option value="a0EUg000003O6XBMA0">Tesla Powerwall 3 (AC)</option>
                                                    <option value="a0E1N00000J1orgUAB">Tesla Powerwall 2</option>
                                                    <option value="a0E6O00000pTTGzUAO">SolarEdge ESSD (TOU)</option>
                                                    <option value="a0E6O00000peH06UAE">SolarEdge Home (Back Up)</option>
                                                    <option value="a0EUg0000001YfZMAU">Enphase IQ Battery 5P (TOU)</option>
                                                    <option value="a0EUg0000001YkPMAU">Enphase IQ Battery 5P (Back Up)</option>
                                                    <option value="a0E6O00000peQ81UAE">Enphase Encharge 3T (TOU)</option>
                                                    <option value="a0EUg000000lGMHMA2">Enphase IQ Battery 3 (Backup)</option>
                                                    </Field>
                                                    <ErrorMessage name="battery" component={ErrorLabel} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="w-50">Number of Batteries</td>
                                                <td className="w-50 font-weight-bold">
                                                    <Field className="input input-plain" name="numOfBatteries" type="number" />
                                                    <ErrorMessage name="numOfBatteries" component={ErrorLabel} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="w-50">Battery Upsell</td>
                                                <td>
                                                    <Field name="baterryCommission" as="select">
                                                    <option value=""></option>
                                                    { this.state.batteryCommissionValues.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                                                    </Field>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="w-50">Battery Monthly Bill</td>
                                                <td className="w-50 font-weight-bold">{this.state.prelimProposal.Monthly_Battery_Amount__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Monthly_Battery_Amount__c) : "---"}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-50">Solar Monthly Bill</td>
                                                <td className="w-50 font-weight-bold">{this.state.prelimProposal.Monthly_Bill_Amount__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Monthly_Bill_Amount__c) : "---"}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-50">Total Monthly Bill</td>
                                                <td className="w-50 font-weight-bold">{this.state.prelimProposal.Total_Monthly_Payment__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Total_Monthly_Payment__c) : "---"}</td>
                                            </tr>
                                            </tbody>
                                        </table>

                                        <div className="row mt-5">
                                            <div className="col-md-6">
                                                <h2>Address</h2>
                                                <div className="mt-3">
                                                    <Field className="input input-plain" name="street" type="text" />
                                                    <div className="text-sm">Street</div>
                                                </div>
                                                <div className="mt-3">
                                                    <Field className="input input-plain" name="city" type="text" />
                                                    <div className="text-sm">City</div>
                                                </div>
                                                <div className="mt-3">
                                                    <Field className="input input-plain" as="select" name="state">
                                                        <option value=""></option>
                                                        <option value="CA">CA</option>
                                                        <option value="TX">TX</option>
                                                    </Field>
                                                    <div className="text-sm">State</div>
                                                </div>
                                                <div className="mt-3">
                                                    <Field className="input input-plain" name="zip" type="text" />
                                                    <div className="text-sm">Zip Code</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mt-5">
                                            <div className="col-md-6">
                                                <h2>Contact</h2>
                                                <div className="mt-3">
                                                    <Field className="input input-plain" name="email" type="text" />
                                                    <div className="text-sm">Email</div>
                                                </div>
                                                <div className="mt-3">
                                                    <Field className="input input-plain" name="phone" type="text" />
                                                    <div className="text-sm">Phone</div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* ----- Usage Details: ----- */}
                                        <h2>Usage</h2>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td className="w-15">Jan Usage</td>
                                                <td className="w-25 font-weight-bold">{this.state.usageRecord.January_Usage__c ? this.state.usageRecord.January_Usage__c.toFixed(2) : "---"}</td>
                                                <td className="w-25">Jan Bill</td>
                                                <td className="w-25 font-weight-bold">{this.state.usageRecord.January_Bill__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.usageRecord.January_Bill__c) : "---"}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-25">Feb Usage</td>
                                                <td className="w-25 font-weight-bold">{this.state.usageRecord.February_Usage__c ? this.state.usageRecord.February_Usage__c.toFixed(2) : "---"}</td>
                                                <td className="w-25">Feb Bill</td>
                                                <td className="w-25 font-weight-bold">{this.state.usageRecord.February_Bill__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.usageRecord.February_Bill__c) : "---"}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-25">Mar Usage</td>
                                                <td className="w-25 font-weight-bold">{this.state.usageRecord.March_Usage__c ? this.state.usageRecord.March_Usage__c.toFixed(2) : "---"}</td>
                                                <td className="w-25">Mar Bill</td>
                                                <td className="w-25 font-weight-bold">{this.state.usageRecord.March_Bill__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.usageRecord.March_Bill__c) : "---"}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-25">Apr Usage</td>
                                                <td className="w-25 font-weight-bold">{this.state.usageRecord.April_Usage__c ? this.state.usageRecord.April_Usage__c.toFixed(2) : "---"}</td>
                                                <td className="w-25">Apr Bill</td>
                                                <td className="w-25 font-weight-bold">{this.state.usageRecord.April_Bill__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.usageRecord.April_Bill__c) : "---"}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-25">May Usage</td>
                                                <td className="w-25 font-weight-bold">{this.state.usageRecord.May_Usage__c ? this.state.usageRecord.May_Usage__c.toFixed(2) : "---"}</td>
                                                <td className="w-25">May Bill</td>
                                                <td className="w-25 font-weight-bold">{this.state.usageRecord.May_Bill__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.usageRecord.May_Bill__c) : "---"}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-25">Jun Usage</td>
                                                <td className="w-25 font-weight-bold">{this.state.usageRecord.June_Usage__c ? this.state.usageRecord.June_Usage__c.toFixed(2) : "---"}</td>
                                                <td className="w-25">Jun Bill</td>
                                                <td className="w-25 font-weight-bold">{this.state.usageRecord.June_Bill__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.usageRecord.June_Bill__c): "---"}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-25">Jul Usage</td>
                                                <td className="w-25 font-weight-bold">{this.state.usageRecord.July_Usage__c ? this.state.usageRecord.July_Usage__c.toFixed(2) : "---"}</td>
                                                <td className="w-25">Jul Bill</td>
                                                <td className="w-25 font-weight-bold">{this.state.usageRecord.July_Bill__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.usageRecord.July_Bill__c) : "---"}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-25">Aug Usage</td>
                                                <td className="w-25 font-weight-bold">{this.state.usageRecord.August_Usage__c ? this.state.usageRecord.August_Usage__c.toFixed(2) : "---"}</td>
                                                <td className="w-25">Aug Bill</td>
                                                <td className="w-25 font-weight-bold">{this.state.usageRecord.August_Bill__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.usageRecord.August_Bill__c) : "---"}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-25">Sep Usage</td>
                                                <td className="w-25 font-weight-bold">{this.state.usageRecord.September_Usage__c ? this.state.usageRecord.September_Usage__c.toFixed(2) : "---"}</td>
                                                <td className="w-25">Sep Bill</td>
                                                <td className="w-25 font-weight-bold">{this.state.usageRecord.September_Bill__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.usageRecord.September_Bill__c) : "---"}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-25">Oct Usage</td>
                                                <td className="w-25 font-weight-bold">{this.state.usageRecord.October_Usage__c ? this.state.usageRecord.October_Usage__c.toFixed(2) : "---"}</td>
                                                <td className="w-25">Oct Bill</td>
                                                <td className="w-25 font-weight-bold">{this.state.usageRecord.October_Bill__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.usageRecord.October_Bill__c) : "---"}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-25">Nov Usage</td>
                                                <td className="w-25 font-weight-bold">{this.state.usageRecord.November_Usage__c ? this.state.usageRecord.November_Usage__c.toFixed(2) : "---"}</td>
                                                <td className="w-25">Nov Bill</td>
                                                <td className="w-25 font-weight-bold">{this.state.usageRecord.November_Bill__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.usageRecord.November_Bill__c) : "---"}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-25">Dec Usage</td>
                                                <td className="w-25 font-weight-bold">{this.state.usageRecord.December_Usage__c ? this.state.usageRecord.December_Usage__c.toFixed(2) : "---"}</td>
                                                <td className="w-25">Dec Bill</td>
                                                <td className="w-25 font-weight-bold">{this.state.usageRecord.December_Bill__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.usageRecord.December_Bill__c) : "---"}</td>
                                            </tr>
                                            </tbody>
                                        </table>

                                        {/* ----- Lead Notes: ----- */}
                                        <div className="mt-5">
                                            <h2>Lead Notes</h2>
                                            <textarea maxLength={3000} defaultValue={this.state.lead.Sales_Notes__c} onChange={(event) => this.setState({leadNotes: event.target.value})} rows="10"></textarea>
                                            <button className="btn btn-primary" disabled={this.state.leadNotesDisabled} onClick={this.saveLeadNotes}>Save Notes</button>
                                            {
                                                this.state.leadNoteSaveSuccess ? 
                                                <p className={css.LeadDetails__BoldFont}>&nbsp;&nbsp;&nbsp;Saved Successfully</p>
                                                :
                                                ''
                                            }
                                        </div>

                                        <div className="row mt-5">
                                            <h2>Requested</h2>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td>Lead Purpose</td>
                                                        <td>
                                                        <Field name="leadPurpose" as="select">
                                                            { this.leadPurposeOptions.map(option => <option key={option} value={option}>{option}</option>) }
                                                        </Field>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="w-50">Preferred Type</td>
                                                        <td className="w-50 font-weight-bold">{this.state.lead.Preferred_Type__c ? this.state.lead.Preferred_Type__c : "---"}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="w-50">Preferred Financier</td>
                                                        <td className="w-50 font-weight-bold">{this.state.lead.Preferred_Financier__c ? this.state.lead.Preferred_Financier__c : "---"}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="w-50">Full Deal Requested</td>
                                                        <td className="w-50 font-weight-bold">{this.state.lead.Full_Deal_Requested__c ? formatDataText(this.state.lead.Full_Deal_Requested__c) : "---"}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="w-50">Preferred Offset</td>
                                                        <td className="w-50 font-weight-bold">{this.state.lead.Preferred_Offset__c ? this.state.lead.Preferred_Offset__c + "%" : "---"}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="w-50">Preferred Escalator</td>
                                                        <td className="w-50 font-weight-bold">{this.state.lead.Preferred_Escalator__c ? this.state.lead.Preferred_Escalator__c : "---"}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </Form>
                                </Formik>
                            </div> {/* /edit lead+address info */}

                            {/* ---------- Display Mode: ---------- */}
                            <div className={this.state.isEditingLead ? 'd-none' : 'mt-2'}>
                                <div className="row py-2 text-md">
                                    <div className="col-12 col-sm-4"><h6>Rep 1</h6>
                                        <div>{this.state.firstRep}</div>
                                        <div>{this.state.lead.Sales_Rep_1_Setter_Closer__c ? this.state.lead.Sales_Rep_1_Setter_Closer__c : '---'}</div>
                                    </div>
                                    <div className="col-12 col-sm-4"><h6>Rep 2</h6>
                                        <div>{this.state.secondRep ? this.state.secondRep : '---'}</div>
                                        <div>{this.state.lead.Sales_Rep_2_Setter_Closer__c ? this.state.lead.Sales_Rep_2_Setter_Closer__c : '---'}</div>
                                    </div>
                                </div>
                                {/* ----- Lead Details: ----- */}
                                <h2>Lead Details</h2>
                                <table>
                                    <tbody>
                                    <tr>
                                        <td className="w-50">Name</td>
                                        <td className="w-50 font-weight-bold">{this.state.lead.Name ? this.state.lead.Name : "---"}</td>
                                    </tr> 
                                    <tr>
                                        <td className="w-50">Lead Status</td>
                                        <td className="w-50 font-weight-bold">{this.state.lead.Status__c ? this.state.lead.Status__c : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-50">Preferred Financier</td>
                                        <td className="w-50 font-weight-bold">{this.state.lead.Preferred_Financier__c ? this.state.lead.Preferred_Financier__c : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-50">Prelim Appt Time</td>
                                        <td className="w-50 font-weight-bold">{ formatShortDate(this.state.lead.Prelim_Appointment_Time__c) }</td>
                                    </tr>
                                    <tr>
                                        <td className="w-50">Qualified Sit</td>
                                        <td className="w-50 font-weight-bold">{ formatShortDate(this.state.lead.Sat__c) }</td>
                                    </tr>
                                    <tr>
                                        <td className="w-50">Primary Title</td>
                                        <td className="w-50 font-weight-bold">{this.state.lead.Primary_Title__c ? this.state.lead.Primary_Title__c : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-50">Secondary Title</td>
                                        <td className="w-50 font-weight-bold">{this.state.lead.Secondary_Title__c ? this.state.lead.Secondary_Title__c : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-50">Title Name for Credit</td>
                                        <td className="w-50 font-weight-bold">{this.state.lead.Title_Name_for_Credit__c}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-50">Contract Status</td>
                                        <td className="w-50 font-weight-bold">{this.state.prelimProposal.Contract_New__r ? this.state.prelimProposal.Contract_New__r.Status__c : '---'}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-50">Customer Type</td>
                                        <td className="w-50 font-weight-bold">{this.state.lead.Customer_Type__c ? this.state.lead.Customer_Type__c.replaceAll(';', ', ') : "---"}</td>
                                    </tr>
                                    </tbody>
                                </table>

                                {/* ----- System Details: ----- */}
                                <h2 className='pt-2'>System Details</h2>
                                <table>
                                    <tbody>
                                    <tr>
                                        <td className="w-50">System Size</td>
                                        <td className="w-50 font-weight-bold">{this.state.prelimProposal.System_Size__c ? this.state.prelimProposal.System_Size__c : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-50">EPC</td>
                                        <td className="w-50 font-weight-bold">{this.state.prelimProposal.EPC__c ? (this.state.prelimProposal.EPC__c).toFixed(2) : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-50">kWh</td>
                                        <td className="w-50 font-weight-bold">{this.state.prelimProposal.Price_per_kWh__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD', minimumFractionDigits: 3}).format(this.state.prelimProposal.Price_per_kWh__c) : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-50">Price Per Watt</td>
                                        <td className="w-50 font-weight-bold">{this.state.prelimProposal.Price_per_Watt__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Price_per_Watt__c) : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-50">Amount</td>
                                        <td className="w-50 font-weight-bold">{this.state.prelimProposal.Price_per_Watt__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Amount__c) : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-50">Annual Production</td>
                                        <td className="w-50 font-weight-bold">{this.state.prelimProposal.Est_Year_One_Production__c ? this.state.prelimProposal.Est_Year_One_Production__c.toLocaleString(undefined, {maximumFractionDigits:0}) : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-50">Annual Usage</td>
                                        <td className="w-50 font-weight-bold">{this.state.prelimProposal.Annual_Usage__c ? this.state.prelimProposal.Annual_Usage__c.toLocaleString(undefined, {maximumFractionDigits:0}) : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-50">Utility Provider</td>
                                        <td className="w-50 font-weight-bold">{this.state.leadUtilityProvider ? this.state.leadUtilityProvider : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-50">Battery</td>
                                        <td className="w-50 font-weight-bold">{this.state.prelimProposal.Battery_Type__c ? this.state.prelimProposal.Battery_Type__r.Name : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-50">Number of Batteries</td>
                                        <td className="w-50 font-weight-bold">{this.state.prelimProposal.Number_of_Batteries__c ? this.state.prelimProposal.Number_of_Batteries__c : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-50">Battery Upsell</td>
                                        <td className="w-50 font-weight-bold">{this.state.prelimProposal.Battery_Commission__c ? this.state.prelimProposal.Battery_Commission__c : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-50">Battery Monthly Bill</td>
                                        <td className="w-50 font-weight-bold">{this.state.prelimProposal.Monthly_Battery_Amount__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Monthly_Battery_Amount__c) : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-50">Solar Monthly Bill</td>
                                        <td className="w-50 font-weight-bold">{this.state.prelimProposal.Monthly_Bill_Amount__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Monthly_Bill_Amount__c) : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-50">Total Monthly Bill</td>
                                        <td className="w-50 font-weight-bold">{this.state.prelimProposal.Total_Monthly_Payment__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Total_Monthly_Payment__c) : this.state.prelimProposal.Monthly_Bill_Amount__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Monthly_Bill_Amount__c) : "---"}</td>
                                    </tr>
                                    </tbody>
                                </table>

                                {/* ----- Address: ----- */}
                                <h2>Address</h2>
                                <table>
                                    <tbody>
                                    <tr>
                                        <td className="w-50">Street</td>
                                        <td className="w-50 font-weight-bold"><a className='text-primary' href={`https://www.google.com/maps/place/${this.state.lead.Street}+${this.state.lead.City}+${this.state.lead.State}+${this.state.lead.PostalCode}`} target="_blank" rel="noreferrer noopener">{this.state.lead.Street}</a></td>
                                    </tr>
                                    <tr>
                                        <td className="w-50">City</td>
                                        <td className="w-50 font-weight-bold">{this.state.lead.City}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-50">State</td>
                                        <td className="w-50 font-weight-bold">{this.state.lead.State}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-50">Zip Code</td>
                                        <td className="w-50 font-weight-bold">{this.state.lead.PostalCode}</td>
                                    </tr>
                                    </tbody>
                                </table>
                                {/* /display lead+address info */}

                                {/* ----- Contact: ----- */}
                                <div className="mt-5">
                                    <h2>Contact</h2>
                                    <table>
                                        <tbody>
                                        <tr>
                                            <td className="w-50">Email</td>
                                            <td className="w-50 font-weight-bold">
                                                <a href="mailto:{opportunity.Email__c}">
                                                    {this.state.lead.Email}
                                                </a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="w-50">Phone</td>
                                            <td className="w-50 font-weight-bold"><a href={`tel:${this.state.lead.Phone}`}>{this.state.lead.Phone}</a>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>

                                {/* ----- Usage Details: ----- */}
                                <h2>Usage</h2>
                                <table>
                                    <tbody>
                                    <tr>
                                        <td className="w-15">Jan Usage</td>
                                        <td className="w-25 font-weight-bold">{this.state.usageRecord.January_Usage__c ? this.state.usageRecord.January_Usage__c.toFixed(2) : "---"}</td>
                                        <td className="w-25">Jan Bill</td>
                                        <td className="w-25 font-weight-bold">{this.state.usageRecord.January_Bill__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.usageRecord.January_Bill__c) : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-25">Feb Usage</td>
                                        <td className="w-25 font-weight-bold">{this.state.usageRecord.February_Usage__c ? this.state.usageRecord.February_Usage__c.toFixed(2) : "---"}</td>
                                        <td className="w-25">Feb Bill</td>
                                        <td className="w-25 font-weight-bold">{this.state.usageRecord.February_Bill__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.usageRecord.February_Bill__c) : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-25">Mar Usage</td>
                                        <td className="w-25 font-weight-bold">{this.state.usageRecord.March_Usage__c ? this.state.usageRecord.March_Usage__c.toFixed(2) : "---"}</td>
                                        <td className="w-25">Mar Bill</td>
                                        <td className="w-25 font-weight-bold">{this.state.usageRecord.March_Bill__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.usageRecord.March_Bill__c) : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-25">Apr Usage</td>
                                        <td className="w-25 font-weight-bold">{this.state.usageRecord.April_Usage__c ? this.state.usageRecord.April_Usage__c.toFixed(2) : "---"}</td>
                                        <td className="w-25">Apr Bill</td>
                                        <td className="w-25 font-weight-bold">{this.state.usageRecord.April_Bill__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.usageRecord.April_Bill__c) : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-25">May Usage</td>
                                        <td className="w-25 font-weight-bold">{this.state.usageRecord.May_Usage__c ? this.state.usageRecord.May_Usage__c.toFixed(2) : "---"}</td>
                                        <td className="w-25">May Bill</td>
                                        <td className="w-25 font-weight-bold">{this.state.usageRecord.May_Bill__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.usageRecord.May_Bill__c) : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-25">Jun Usage</td>
                                        <td className="w-25 font-weight-bold">{this.state.usageRecord.June_Usage__c ? this.state.usageRecord.June_Usage__c.toFixed(2) : "---"}</td>
                                        <td className="w-25">Jun Bill</td>
                                        <td className="w-25 font-weight-bold">{this.state.usageRecord.June_Bill__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.usageRecord.June_Bill__c): "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-25">Jul Usage</td>
                                        <td className="w-25 font-weight-bold">{this.state.usageRecord.July_Usage__c ? this.state.usageRecord.July_Usage__c.toFixed(2) : "---"}</td>
                                        <td className="w-25">Jul Bill</td>
                                        <td className="w-25 font-weight-bold">{this.state.usageRecord.July_Bill__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.usageRecord.July_Bill__c) : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-25">Aug Usage</td>
                                        <td className="w-25 font-weight-bold">{this.state.usageRecord.August_Usage__c ? this.state.usageRecord.August_Usage__c.toFixed(2) : "---"}</td>
                                        <td className="w-25">Aug Bill</td>
                                        <td className="w-25 font-weight-bold">{this.state.usageRecord.August_Bill__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.usageRecord.August_Bill__c) : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-25">Sep Usage</td>
                                        <td className="w-25 font-weight-bold">{this.state.usageRecord.September_Usage__c ? this.state.usageRecord.September_Usage__c.toFixed(2) : "---"}</td>
                                        <td className="w-25">Sep Bill</td>
                                        <td className="w-25 font-weight-bold">{this.state.usageRecord.September_Bill__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.usageRecord.September_Bill__c) : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-25">Oct Usage</td>
                                        <td className="w-25 font-weight-bold">{this.state.usageRecord.October_Usage__c ? this.state.usageRecord.October_Usage__c.toFixed(2) : "---"}</td>
                                        <td className="w-25">Oct Bill</td>
                                        <td className="w-25 font-weight-bold">{this.state.usageRecord.October_Bill__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.usageRecord.October_Bill__c) : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-25">Nov Usage</td>
                                        <td className="w-25 font-weight-bold">{this.state.usageRecord.November_Usage__c ? this.state.usageRecord.November_Usage__c.toFixed(2) : "---"}</td>
                                        <td className="w-25">Nov Bill</td>
                                        <td className="w-25 font-weight-bold">{this.state.usageRecord.November_Bill__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.usageRecord.November_Bill__c) : "---"}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-25">Dec Usage</td>
                                        <td className="w-25 font-weight-bold">{this.state.usageRecord.December_Usage__c ? this.state.usageRecord.December_Usage__c.toFixed(2) : "---"}</td>
                                        <td className="w-25">Dec Bill</td>
                                        <td className="w-25 font-weight-bold">{this.state.usageRecord.December_Bill__c ? Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.usageRecord.December_Bill__c) : "---"}</td>
                                    </tr>
                                    </tbody>
                                </table>

                                {/* ----- Lead Notes: ----- */}
                                <div className="mt-5">
                                    <h2>Lead Notes</h2>
                                    <textarea maxLength={3000} defaultValue={this.state.lead.Sales_Notes__c} onChange={(event) => this.setState({leadNotes: event.target.value})} rows="10"></textarea>
                                    <button className="btn btn-primary" disabled={this.state.leadNotesDisabled} onClick={this.saveLeadNotes}>Save Notes</button>
                                    {
                                        this.state.leadNoteSaveSuccess ? 
                                        <p className={css.LeadDetails__BoldFont}>&nbsp;&nbsp;&nbsp;Saved Successfully</p>
                                        :
                                        ''
                                    }
                                </div>
                            
                                {/* ----- Requested: ----- */}
                                <div className="mt-5">
                                    <h2>Requested</h2>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className="w-50">Lead Purpose</td>
                                                <td className="w-50 font-weight-bold">{this.state.lead.Lead_Purpose__c ? this.state.lead.Lead_Purpose__c : "---"}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-50">Preferred Type</td>
                                                <td className="w-50 font-weight-bold">{this.state.lead.Preferred_Type__c ? this.state.lead.Preferred_Type__c : "---"}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-50">Preferred Financier</td>
                                                <td className="w-50 font-weight-bold">{this.state.lead.Preferred_Financier__c ? this.state.lead.Preferred_Financier__c : "---"}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-50">Full Deal Requested</td>
                                                <td className="w-50 font-weight-bold">{this.state.lead.Full_Deal_Requested__c ? formatDataText(this.state.lead.Full_Deal_Requested__c) : "---"}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-50">Preferred Offset</td>
                                                <td className="w-50 font-weight-bold">{this.state.lead.Preferred_Offset__c ? this.state.lead.Preferred_Offset__c + "%" : "---"}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-50">Preferred Escalator</td>
                                                <td className="w-50 font-weight-bold">{this.state.lead.Preferred_Escalator__c ? this.state.lead.Preferred_Escalator__c : "---"}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* ----- Attempts ----- */}
                            <div className="mt-5">
                                <h2>Attempts</h2>
                                <table className={this.state.attempts.length ? '' : 'd-none'}>
                                    <thead>
                                    <tr>
                                        <th>Type</th>
                                        <th>Date</th>
                                        <th>Outcome</th>
                                        <th>Notes</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        this.state.attempts.map(attempt => {
                                            return (
                                                <tr key={attempt.Id} className={attempt.Call_Outcome__c === 'Appt Set' ? css.LeadDetails__RowSuccess : ''}>
                                                    <td>{attempt.Type__c}</td>
                                                    <td>{moment(attempt.CreatedDate).format('MM/DD/YYYY @ hh:mmA')}</td>
                                                    <td>{attempt.Call_Outcome__c}</td>
                                                    <td>{attempt.Notes__c}</td>
                                                </tr>
                                            );
                                        })
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* ---------- Messages: ---------- */}
                        <div className="col-12 col-md-4">
                            <div className="mt-4 mb-1">Write A Message</div>
                            <Formik
                                initialValues={{
                                    message: '',
                                    group: [] // checkboxes of 'group' tags
                                }}

                                validate={
                                    (values)=> {
                                        const errors = {};

                                        if (!values.group.length) {
                                            errors.group = 'You Must Select a Group to Tag';
                                        }

                                        if(values.message === '') {
                                            errors.message = 'Message Is Blank'
                                        }

                                        return errors;
                                    }
                                }

                                onSubmit={
                                    // n.b. this method is an exact copy as the one in CustomerDetails:
                                    (values, { resetForm }) => {
                                        this.setState({disableSubmit: true});

                                        setTimeout(() => this.setState({disableSubmit: false}), 5000);
                                        // convert checked values to list of boolean values:
                                        const mention = this.messageGroupTypes.map(groupType => values.group.includes(groupType));

                                        const message = `${this.props.user.name} -- \n${values.message.trim()} `;

                                        const payload = {
                                            message,
                                            id: this.leadId,
                                            mention,
                                        };

                                        axios.post(
                                            '/sf/chatter/message',
                                            payload,
                                            {
                                                cancelToken: this.source.token
                                            })
                                            .then((res) => {
                                                // fetch updated chatter:
                                                this.setState({
                                                    chatter: [res.data, ...this.state.chatter]
                                                });

                                                // clear form:
                                                resetForm();
                                            });
                                    }
                                }
                            >
                                <Form>
                                    <Field name="message" rows="8" as="textarea" />
                                    <ErrorMessage name="message" component={ErrorLabel} />
                                    
                                    {/* ----- checkboxes: ----- */}
                                    <div>
                                        {
                                            this.messageGroupTypes.map(group => {
                                                return (
                                                    <div key={group}>
                                                        <Field className="mr-2" name="group" value={group} type="checkbox"/>
                                                        <span>Tag <span className="font-weight-bold">{group}</span> Team</span>
                                                    </div>
                                                );
                                            })
                                        }
                                        <div className="mt-2">
                                            <ErrorMessage name="group" component={ErrorLabel} />
                                        </div>
                                    </div> {/* /checkboxes section */}
                                    <div className="text-right mt-3">
                                        <button className="btn btn-primary" type="submit" disabled={this.state.disableSubmit}>Submit</button>
                                    </div>
                                </Form>
                            </Formik>

                            {/* ----- chatter: ----- */}
                            <div className={css.LeadDetails__Chatter}>
                                {
                                    this.state.chatter.map(chat => {
                                        return (
                                            <div key={chat.id} className={chat.body.text ? 'mt-5' : 'd-none'}>
                                                <h2>Comment</h2>
                                                <div className="d-flex justify-content-between">
                                                    <div className="text-primary">{chat.actor ? chat.actor.displayName : ''}</div>
                                                    <div className="text-primary">{moment(chat.createdDate).format('MM/DD/YYYY')}</div>
                                                </div>
                                                <p className="my-3">
                                                    {/* n.b. we must decode HTML entities to prevent XSS: */}
                                                    {
                                                        he.decode(chat.body.text).includes('\n')  ?
                                                        <div>
                                                            {this.splitString(he.decode(chat.body.text)).map(s => {
                                                                return (
                                                                    <span>{s}<br></br></span>
                                                                );
                                                            })}
                                                        </div>
                                                        :
                                                        <span>
                                                            {he.decode(chat.body.text || '')}
                                                        </span>
                                                    }
                                                </p>

                                                {/* ----- comments: ----- */}
                                                {
                                                    // we need to guard against non-existent properties -- which would throw an error:
                                                    (
                                                        chat.capabilities &&
                                                        chat.capabilities.comments &&
                                                        chat.capabilities.comments.page &&
                                                        chat.capabilities.comments.page.items.length
                                                    )
                                                        ?
                                                        (
                                                            <div className={`${css.LeadDetails__Comments} ml-3`}>
                                                                {
                                                                    chat.capabilities.comments.page.items.map(comment => {
                                                                        return (
                                                                            <p key={comment.id} className={
                                                                                (
                                                                                    comment.user.displayName === 'System Admin' &&
                                                                                    !comment.body.text.includes(this.props.user.name)
                                                                                )
                                                                                    ?
                                                                                    ''
                                                                                    :
                                                                                    'text-green'
                                                                            }>
                                                                                {/* n.b. we must decode HTML entities to prevent XSS: */}
                                                                                {
                                                                                    he.decode(comment.body.text).includes("\n") ?
                                                                                    
                                                                                    <div>
                                                                                        {he.decode(comment.user.name)}--<br></br>
                                                                                        {this.splitString(he.decode(comment.body.text)).map(s => {
                                                                                            return (
                                                                                                <span>{s}<br></br></span>
                                                                                            );
                                                                                        })}
                                                                                    </div>
                                                                                    :
                                                                                    <span>
                                                                                        {he.decode(comment.user.name)}-- { he.decode(comment.body.text)  }
                                                                                    </span>
                                                                                }
                                                                                <p className="my-3">{moment(comment.createdDate).format('MM/DD/YYYY hh:mm a')}</p>
                                                                            </p>
                                                                        );
                                                                    })
                                                                }
                                                            </div>
                                                        )
                                                        :
                                                        null
                                                }

                                                {/* ----- reply to message: ----- */}
                                                <div className="ml-3">
                                                    <Accordion
                                                        header={<span>Reply</span>}
                                                        content={
                                                            <div>
                                                                <div>Reply</div>
                                                                <Formik
                                                                    initialValues={{
                                                                        reply: ''
                                                                    }}

                                                                    onSubmit={
                                                                        (values, { resetForm }) => {
                                                                            this.setState({disableSubmit: true});

                                                                            setTimeout(() => this.setState({disableSubmit: false}), 5000);

                                                                            const payload = {
                                                                                id: chat.id,
                                                                                message: `${this.props.user.name} -- ${values.reply.trim()}`
                                                                            };

                                                                            axios.post(
                                                                                '/sf/chatter/comment',
                                                                                payload,
                                                                                {
                                                                                    cancelToken: this.source.token
                                                                                })
                                                                                .then(() => {
                                                                                    resetForm();
                                                                                    this.getChatter();
                                                                                })
                                                                                .catch(err => console.log('(POST) error while posting comment: \n', err));
                                                                        }
                                                                    }
                                                                >
                                                                    <Form>
                                                                        <Field name="reply" as="textarea" />
                                                                        <div className="text-right mt-2">
                                                                            <button className="btn btn-primary" type="submit" disabled={this.state.disableSubmit}>Submit</button>
                                                                        </div>
                                                                    </Form>
                                                                </Formik>
                                                            </div>
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        );
                                    })
                                }
                            </div> {/* /chatter section */}
                        </div> {/* /messages section */}
                    </div> {/* /.row */}
                </div>

                {/* ---------- Log Attempt Modal: ---------- */}
                <Modal
                    isOpen={this.state.isModelOpen}
                    onRequestClose={() => this.setState({isModelOpen: false})}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                >
                    <div className="d-flex justify-content-between">
                        <h3>Log Attempt</h3>

                        <span className="mx-2 cursor-pointer">
                            <FontAwesomeIcon icon={faTimes} onClick={() => this.setState({isModelOpen: false})} />
                        </span>
                    </div>

                    <div className="mt-3">
                        <label htmlFor="logAttemptType">Type</label>
                        <select id="logAttemptType" value={this.state.logAttemptType} onChange={(event) => this.setState({logAttemptType: event.target.value})}>
                            <option disabled value=""></option>
                            <option value="Email">Email</option>
                            <option value="Text">Text</option>
                            <option value="Call">Call</option>
                        </select>
                    </div>

                    <div className={this.state.logAttemptType === 'Call' ? 'mt-3' : 'd-none'}>
                        <label htmlFor="logAttemptOutcome">Call Outcome</label>
                        <select id="logAttemptOutcome" value={this.state.logAttemptOutcome} onChange={(event) => this.setState({logAttemptOutcome: event.target.value})}>
                            <option disabled value=""></option>
                            <option value="No Answer">No Answer</option>
                            <option value="Left VM">Left VM</option>
                            <option value="Contacted">Contacted</option>
                            <option value="Appt Set">Appt Set</option>
                        </select>
                    </div>

                    <div className="mt-3">
                        <label htmlFor="logAttemptNotes">Notes</label>
                        <textarea id="logAttemptNotes" value={this.state.logAttemptNotes} onChange={(event) => this.setState({logAttemptNotes: event.target.value})} />
                    </div>

                    <div className="mt-3 text-right">
                        <button className="btn btn-primary" type="button" onClick={() => this.modalLogAttemptOnClick()}>Save Attempt</button>
                    </div>
                </Modal>

                {/* ---------- Usage Modal: ---------- */}
                <Modal
                    isOpen={this.state.usageModalOpen}
                    onRequestClose={() => this.setState({usageModalOpen: false})}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                        },
                        content: {
                            background: 'rgba(53, 53, 53)',
                        }
                    }}
                >
                    <div className="d-flex justify-content-between text-white">
                        <h3>Calculate Usage/Bill</h3>

                        <span className="mx-2 cursor-pointer">
                            <FontAwesomeIcon icon={faTimes} onClick={() => this.clearEverything()} />
                        </span>
                    </div>

                    <div className="mt-3 text-white">
                        <label htmlFor="usageCalcType">Bill Type*</label>
                        <select id="usageCalcType" value={this.state.usageCalcType} onChange={(event) => this.setState({usageCalcType: event.target.value})}>
                            <option disabled value=""></option>
                            <option value="Usage">Usage</option>
                            <option value="Monthly Bill">Monthly Bill</option>
                        </select>
                    </div>

                    <div className="mt-3 text-white">
                        <label htmlFor="usageCalcType">Utility Provider*</label>
                        <select id="usageCalcType" value={this.state.utilProvider} onChange={(event) => this.rateSchedBuilder(event.target.value)}>
                            <option disabled value=""></option>
                            <option value="pge">PG&E</option>
                            <option value="sce">SCE</option>
                        </select>
                    </div>

                    <div className={this.state.utilProvider !== '' ? 'mt-3 text-white' : 'd-none'}>
                        <label htmlFor="usageCalcType">Utility CCA (If Applicable)</label>
                        {
                            this.state.utilProvider === 'pge' ?

                            <select id="usageCalcType" value={this.state.utilCCA} onChange={(event) => this.rateSchedBuilder(event.target.value)}>
                                <option></option>
                                <option value="ebce">East Bay Community Energy</option>
                                <option value="mcece">MCE Clean Energy</option>
                                <option value="pce">Peninsula Clean Energy</option>
                                <option value="pioneerce">Pioneer Community Energy</option>
                                <option value="scp">Sonoma Clean Power</option>
                                <option value="vce">Valley Clean Energy</option>
                            </select>

                            :

                            <select id="usageCalcType" value={this.state.utilCCA} onChange={(event) => this.rateSchedBuilder(event.target.value)}>
                                <option></option>
                                <option value="avce">Apple Valley Choice Energy</option>
                                <option value="lce">Lancaster Choice Energy</option>
                            </select>
                        }
                    </div>

                    <div className={this.state.utilProvider !== '' ? 'mt-3 text-white' : 'd-none'}>
                        <label htmlFor="utilRateSched">Utility Rate Schedule*</label>
                        {/* <input id="usageCalcType" value={this.state.utilRateSched} onChange={(event) => this.setState({utilRateSched: event.target.value})}></input> */}
                        <select id="utilRateSched" value={this.state.utilRateSched} onChange={(event) => this.setState({utilRateSched: event.target.value})}>
                            {this.state.rateOptions.map(item => {
                                return (<option key={item.id} value={item.value}>{item.value}</option>);
                            })}
                        </select>
                    </div>

                    <div className={this.state.utilRateSched !== '' ? 'mt-3 text-white' : 'd-none'}>
                        <label>Usage Breakdown</label>
                        <table className={css.LeadDetails}>
                            <thead>
                                <tr>
                                    <th className='text-white'>Month: Usage</th>
                                    <th className='text-white'>Usage Amount</th>
                                    <th className='text-white'>Month: Bill</th>
                                    <th className='text-white'>Bill Amount</th>
                                </tr>
                            </thead>
                            {
                                this.state.usageCalcType === 'Usage' ?

                                <tbody>
                                    <tr>
                                        <td>Jan Usage</td>
                                        <td><input disabled={this.state.calcRan} value={this.state.janUsage} type="number" onChange={(event) => this.setState({janUsage: event.target.value})}/></td>
                                        <td>Jan Bill</td>
                                        <td>{this.state.janMonBill}</td>
                                    </tr>
                                    <tr>
                                        <td>Feb Usage</td>
                                        <td><input disabled={this.state.calcRan} value={this.state.febUsage} type="number" onChange={(event) => this.setState({febUsage: event.target.value})}/></td>
                                        <td>Feb Bill</td>
                                        <td>{this.state.febMonBill}</td>
                                    </tr>
                                    <tr>
                                        <td>Mar Usage</td>
                                        <td><input disabled={this.state.calcRan} value={this.state.marUsage} type="number" onChange={(event) => this.setState({marUsage: event.target.value})}/></td>
                                        <td>Mar Bill</td>
                                        <td>{this.state.marMonBill}</td>
                                    </tr>
                                    <tr>
                                        <td>Apr Usage</td>
                                        <td><input disabled={this.state.calcRan} value={this.state.aprUsage} type="number" onChange={(event) => this.setState({aprUsage: event.target.value})}/></td>
                                        <td>Apr Bill</td>
                                        <td>{this.state.aprMonBill}</td>
                                    </tr>
                                    <tr>
                                        <td>May Usage</td>
                                        <td><input disabled={this.state.calcRan} value={this.state.mayUsage} type="number" onChange={(event) => this.setState({mayUsage: event.target.value})}/></td>
                                        <td>May Bill</td>
                                        <td>{this.state.mayMonBill}</td>
                                    </tr>
                                    <tr>
                                        <td>Jun Usage</td>
                                        <td><input disabled={this.state.calcRan} value={this.state.junUsage} type="number" onChange={(event) => this.setState({junUsage: event.target.value})}/></td>
                                        <td>Jun Bill</td>
                                        <td>{this.state.junMonBill}</td>
                                    </tr>
                                    <tr>
                                        <td>Jul Usage</td>
                                        <td><input disabled={this.state.calcRan} value={this.state.julUsage} type="number" onChange={(event) => this.setState({julUsage: event.target.value})}/></td>
                                        <td>Jul Bill</td>
                                        <td>{this.state.julMonBill}</td>
                                    </tr>
                                    <tr>
                                        <td>Aug Usage</td>
                                        <td><input disabled={this.state.calcRan} value={this.state.augUsage} type="number" onChange={(event) => this.setState({augUsage: event.target.value})}/></td>
                                        <td>Aug Bill</td>
                                        <td>{this.state.augMonBill}</td>
                                    </tr>
                                    <tr>
                                        <td>Sep Usage</td>
                                        <td><input disabled={this.state.calcRan} value={this.state.sepUsage} type="number" onChange={(event) => this.setState({sepUsage: event.target.value})}/></td>
                                        <td>Sep Bill</td>
                                        <td>{this.state.sepMonBill}</td>
                                    </tr>
                                    <tr>
                                        <td>Oct Usage</td>
                                        <td><input disabled={this.state.calcRan} value={this.state.octUsage} type="number" onChange={(event) => this.setState({octUsage: event.target.value})}/></td>
                                        <td>Oct Bill</td>
                                        <td>{this.state.octMonBill}</td>
                                    </tr>
                                    <tr>
                                        <td>Nov Usage</td>
                                        <td><input disabled={this.state.calcRan} value={this.state.novUsage} type="number" onChange={(event) => this.setState({novUsage: event.target.value})}/></td>
                                        <td>Nov Bill</td>
                                        <td>{this.state.novMonBill}</td>
                                    </tr>
                                    <tr>
                                        <td>Dec Usage</td>
                                        <td><input disabled={this.state.calcRan} value={this.state.decUsage} type="number" onChange={(event) => this.setState({decUsage: event.target.value})}/></td>
                                        <td>Dec Bill</td>
                                        <td>{this.state.decMonBill}</td>
                                    </tr>
                                    <tr>
                                        <td>Avg kWh</td>
                                        <td>{this.state.averageKWH.toFixed(2)}</td>
                                        <td>Total</td>
                                        <td>${this.state.annualTotal.toFixed(2)}</td>
                                    </tr>
                                </tbody>

                                :

                                <tbody>
                                    <tr>
                                        <td>Jan Usage</td>
                                        <td>{this.state.janUsage}</td>
                                        <td>Jan Bill</td>
                                        <td><input disabled={this.state.calcRan} value={this.state.janMonBill} type="number" onChange={(event) => this.setState({janMonBill: event.target.value})}/></td>
                                    </tr>
                                    <tr>
                                        <td>Feb Usage</td>
                                        <td>{this.state.febUsage}</td>
                                        <td>Feb Bill</td>
                                        <td><input disabled={this.state.calcRan} value={this.state.febMonBill} type="number" onChange={(event) => this.setState({febMonBill: event.target.value})}/></td>
                                    </tr>
                                    <tr>
                                        <td>Mar Usage</td>
                                        <td>{this.state.marUsage}</td>
                                        <td>Mar Bill</td>
                                        <td><input disabled={this.state.calcRan} value={this.state.marMonBill} type="number" onChange={(event) => this.setState({marMonBill: event.target.value})}/></td>
                                    </tr>
                                    <tr>
                                        <td>Apr Usage</td>
                                        <td>{this.state.aprUsage}</td>
                                        <td>Apr Bill</td>
                                        <td><input disabled={this.state.calcRan} value={this.state.aprMonBill} type="number" onChange={(event) => this.setState({aprMonBill: event.target.value})}/></td>
                                    </tr>
                                    <tr>
                                        <td>May Usage</td>
                                        <td>{this.state.mayUsage}</td>
                                        <td>May Bill</td>
                                        <td><input disabled={this.state.calcRan} value={this.state.mayMonBill} type="number" onChange={(event) => this.setState({mayMonBill: event.target.value})}/></td>
                                    </tr>
                                    <tr>
                                        <td>Jun Usage</td>
                                        <td>{this.state.junUsage}</td>
                                        <td>Jun Bill</td>
                                        <td><input disabled={this.state.calcRan} value={this.state.junMonBill} type="number" onChange={(event) => this.setState({junMonBill: event.target.value})}/></td>
                                    </tr>
                                    <tr>
                                        <td>Jul Usage</td>
                                        <td>{this.state.julUsage}</td>
                                        <td>Jul Bill</td>
                                        <td><input disabled={this.state.calcRan} value={this.state.julMonBill} type="number" onChange={(event) => this.setState({julMonBill: event.target.value})}/></td>
                                    </tr>
                                    <tr>
                                        <td>Aug Usage</td>
                                        <td>{this.state.augUsage}</td>
                                        <td>Aug Bill</td>
                                        <td><input disabled={this.state.calcRan} value={this.state.augMonBill} type="number" onChange={(event) => this.setState({augMonBill: event.target.value})}/></td>
                                    </tr>
                                    <tr>
                                        <td>Sep Usage</td>
                                        <td>{this.state.sepUsage}</td>
                                        <td>Sep Bill</td>
                                        <td><input disabled={this.state.calcRan} value={this.state.sepMonBill} type="number" onChange={(event) => this.setState({sepMonBill: event.target.value})}/></td>
                                    </tr>
                                    <tr>
                                        <td>Oct Usage</td>
                                        <td>{this.state.octUsage}</td>
                                        <td>Oct Bill</td>
                                        <td><input disabled={this.state.calcRan} value={this.state.octMonBill} type="number" onChange={(event) => this.setState({octMonBill: event.target.value})}/></td>
                                    </tr>
                                    <tr>
                                        <td>Nov Usage</td>
                                        <td>{this.state.novUsage}</td>
                                        <td>Nov Bill</td>
                                        <td><input disabled={this.state.calcRan} value={this.state.novMonBill} type="number" onChange={(event) => this.setState({novMonBill: event.target.value})}/></td>
                                    </tr>
                                    <tr>
                                        <td>Dec Usage</td>
                                        <td>{this.state.decUsage}</td>
                                        <td>Dec Bill</td>
                                        <td><input disabled={this.state.calcRan} value={this.state.decMonBill} type="number" onChange={(event) => this.setState({decMonBill: event.target.value})}/></td>
                                    </tr>
                                    <tr>
                                        <td>Avg kWh</td>
                                        <td>{(this.state.averageKWH / 12).toFixed(2)}</td>
                                        <td>Total</td>
                                        <td>${this.state.annualTotal.toFixed(2)}</td>
                                    </tr>
                                </tbody>
                            }
                        </table>
                    </div>

                    <div className={this.state.utilRateSched !== '' ? 'mt-3 text-center' : 'd-none'}>
                        <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0" type="button" disabled={this.state.disableSaveUsage} onClick={() => this.saveUsageOnClick()}>Save Usage</button>
                        &nbsp;
                        <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0" type="button" onClick={() => this.genUsageOnClick()}>Run Calculations</button>
                        &nbsp;
                        <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0 text-right" type="button" onClick={() => this.clearAllValues()}>Clear Values</button>
                    </div>
                    <div className={this.state.utilRateSched !== '' ? 'mt-3 text-center' : 'd-none'}>
                        <h2 className='text-white'>Wait for calculations to finish and verify entries before clicking Save Usage</h2>
                    </div>
                </Modal>

                {/* ---------- Pricing Modal: ---------- */}
                <Modal
                    isOpen={this.state.pricingModalOpen}
                    onRequestClose={() => this.setState({
                        pricingModalOpen: false,
                        pricingMethod: '',
                        displayedPPW: Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Price_per_Watt__c),
                        displayedKWH: Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Price_per_kWh__c),
                        monthlyBill: this.state.prelimProposal.Monthly_Bill_Amount__c
                    })}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                        },
                        content: {
                            background: 'rgba(53, 53, 53)',
                        }
                    }}
                >
                    <div className="d-flex justify-content-between text-white">
                        <h3>Pricing</h3>
                        <span className="mx-2 cursor-pointer">
                            <FontAwesomeIcon icon={faTimes} onClick={() => this.setState({
                                pricingModalOpen: false,
                                pricingMethod: '',
                                displayedPPW: Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Price_per_Watt__c),
                                displayedKWH: Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Price_per_kWh__c),
                                monthlyBill: this.state.prelimProposal.Monthly_Bill_Amount__c
                            })} />
                        </span>
                    </div>
                    <div className={this.state.emptyMatrixError !== '' ? css.LeadDetails__Error : 'd-none'}>
                        <h2>{this.state.emptyMatrixError}</h2>
                    </div>
                    {
                        this.state.prodRatioCheck < 1200 ? 
                        <div className='mt-3 text-warning'>Production ratio too low for valid pricing: {this.state.prodRatioCheck}</div>
                        :
                        ''
                    }
                    <div className="mt-3 text-white">
                        <label>Escalator</label>
                        <select id="escalator" value={this.state.prelimProposal.Preferred_Escalator__c}>
                            <option value="3.50">3.5%</option>
                        </select>
                    </div>
                    <div className="mt-3 text-white">
                        <label>Pricing Method</label>
                        <select id="priceMethod" disabled={this.state.disableCalculatePricing} value={this.state.pricingMethod} onChange={(event) => this.setState({
                            pricingMethod: event.target.value,
                            ppw: this.state.prelimProposal.Price_per_Watt__c,
                            kwh: this.state.prelimProposal.Price_per_kWh__c,
                            displayedPPW: Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Price_per_Watt__c),
                            displayedKWH: Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Price_per_kWh__c)
                        })}>
                            <option></option>
                            <option value="ppw">PPW</option>
                            <option value="kwh">kWh</option>
                        </select>
                    </div>
                    {
                        this.state.pricingMethod === 'ppw' ?

                        <div>
                            <div className="mt-3 text-white">
                                <label>Price Per Watt</label>
                                <input className={css.LeadDetails__Input} type='number' value={this.state.ppw} onChange={(e) => this.setState({ppw: e.target.value})}></input>
                                <div className={css.LeadDetails__Error}>
                                    <p>{this.state.ppwError}</p>
                                </div>
                            </div>
                            <div className="mt-3 text-white">
                                <label>kWh</label>
                                <label className={css.LeadDetails__Input}>{this.state.displayedKWH}</label>
                            </div>
                            <div className="mt-3 text-white">
                                <label>Solar Monthly Bill Amount</label>
                                <label className={css.LeadDetails__Input}>{Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.monthlyBill)}</label>
                            </div>
                        </div>

                        :

                        this.state.pricingMethod === 'kwh' ?

                        <div>
                            <div className="mt-3 text-white">
                                <label>Price Per Watt</label>
                                <label className={css.LeadDetails__Input}>{this.state.displayedPPW}</label>
                            </div>
                            <div className="mt-3 text-white">
                                <label>kWh</label>
                                <input className={css.LeadDetails__Input} type='number' value={this.state.kwh} onChange={(e) => this.setState({kwh: e.target.value})}></input>
                                <div className={css.LeadDetails__Error}>
                                    <p>{this.state.kwhError}</p>
                                </div>
                            </div>
                            <div className="mt-3 text-white">
                                <label>Solar Monthly Bill Amount</label>
                                <label className={css.LeadDetails__Input}>{Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.monthlyBill)}</label>
                            </div>
                        </div>

                        :

                        <div></div>
                    }

                    <div className="mt-3 text-center">
                        <button className="btn btn-primary" disabled={this.state.disableCalculatePricing} onClick={() => this.calculatePricing()}>Calculate Pricing</button>
                        &nbsp;
                        <button className="btn btn-primary" disabled={this.state.disableSavePricing} onClick={() => this.savePricing()}>Save Pricing</button>
                        &nbsp;
                        <button className="btn btn-primary" onClick={() => this.setState({
                                pricingModalOpen: false,
                                pricingMethod: '',
                                displayedPPW: Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Price_per_Watt__c),
                                displayedKWH: Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Price_per_kWh__c),
                                monthlyBill: this.state.prelimProposal.Monthly_Bill_Amount__c
                            })}>Cancel</button>
                    </div>
                    <h2>&nbsp;&nbsp;</h2>
                </Modal>

                {/* ---------- Cash Pricing Modal: ---------- */}
                <Modal
                    isOpen={this.state.cashPricingModal}
                    onRequestClose={() => this.setState({
                        cashPricingModal: false,
                        pricingMethod: '',
                        displayedPPW: Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Price_per_Watt__c),
                        displayedAmount: Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Amount__c)
                    })}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                        },
                        content: {
                            background: 'rgba(53, 53, 53)',
                        }
                    }}
                >
                    <div className="d-flex justify-content-between text-white">
                        <h3>Cash Pricing</h3>
                        <span className="mx-2 cursor-pointer">
                            <FontAwesomeIcon icon={faTimes} onClick={() => this.setState({
                                cashPricingModal: false,
                                pricingMethod: '',
                                displayedPPW: Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Price_per_Watt__c),
                                displayedAmount: Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Amount__c)
                            })} />
                        </span>
                    </div>
                    <div className="mt-3 text-white">
                        <label>Maintenance + Monitoring</label>
                        <select id="monitorMain" value={this.state.monitorMain} onChange={(event) => this.setState({monitorMain: event.target.value})}>
                            <option value="false">No</option>
                            <option value="true">Yes</option>
                        </select>
                    </div>
                    <div className="mt-3 text-white">
                        <label>Pricing Method</label>
                        <select id="priceMethod" value={this.state.pricingMethod} onChange={(event) => this.setState({
                            pricingMethod: event.target.value,
                            ppw: this.state.prelimProposal.Price_per_Watt__c,
                            amount: this.state.prelimProposal.Amount__c,
                            displayedPPW: Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Price_per_Watt__c),
                            displayedAmount: Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Amount__c)
                        })}>
                            <option></option>
                            <option value="ppw">PPW</option>
                            <option value="amount">Amount</option>
                        </select>
                    </div>
                    {
                        this.state.pricingMethod === 'ppw' ?

                        <div>
                            <div className="mt-3 text-white">
                                <label>Price Per Watt</label>
                                <input className={css.LeadDetails__Input} type='number' value={this.state.ppw} onChange={(e) => this.setState({ppw: e.target.value})}></input>
                                <div className={css.LeadDetails__Error}>
                                    <p>{this.state.ppwError}</p>
                                </div>
                            </div>
                            <div className="mt-3 text-white">
                                <label>Amount</label>
                                <label className={css.LeadDetails__Input}>{this.state.displayedAmount}</label>
                            </div>
                        </div>

                        :

                        this.state.pricingMethod === 'amount' ?

                        <div>
                            <div className="mt-3 text-white">
                                <label>Price Per Watt</label>
                                <label className={css.LeadDetails__Input}>{this.state.displayedPPW}</label>
                            </div>
                            <div className="mt-3 text-white">
                                <label>Amount</label>
                                <input className={css.LeadDetails__Input} type='number' value={this.state.amount} onChange={(e) => this.setState({amount: e.target.value})}></input>
                                <div className={css.LeadDetails__Error}>
                                    <p>{this.state.kwhError}</p>
                                </div>
                            </div>
                        </div>

                        :

                        <div></div>
                    }

                    <div className="mt-3 text-center">
                        <button className="btn btn-primary" disabled={this.state.disableCalculatePricing} onClick={() => this.calculateCashPricing()}>Calculate Pricing</button>
                        &nbsp;
                        <button className="btn btn-primary" disabled={this.state.disableSavePricing} onClick={() => this.saveCashPricing()}>Save Pricing</button>
                        &nbsp;
                        <button className="btn btn-primary" onClick={() => this.setState({
                                cashPricingModal: false,
                                pricingMethod: '',
                                displayedPPW: Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Price_per_Watt__c),
                                displayedAmount: Intl.NumberFormat('en-US', {style:'currency',currency: 'USD'}).format(this.state.prelimProposal.Amount__c)
                            })}>Cancel</button>
                    </div>
                    <h2>&nbsp;&nbsp;</h2>
                </Modal>

                {/* ---------- Convert Lead Modal: ---------- */}
                <Modal
                    isOpen={this.state.leadConvertModalIsOpen}
                    onRequestClose={() => this.setState({leadConvertModalIsOpen: false})}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                        },
                        content: {
                            background: 'rgba(53, 53, 53)',
                        }
                    }}
                >
                    {
                        this.state.leadConvertConfirm ? 
                        <div className="mt-3 text-center text-white">
                            <h2>Convert Lead Confirmation</h2>
                            <div className="mt-3 pb-3 text-white">
                                <label>Is there an existing V3 system at this address?</label>
                                <select id="existingCustomer" onChange={(e) => this.setState({existingCustomer: e.target.value})}>
                                    <option value="No">No</option>
                                    <option value="Yes">Yes</option>
                                </select>
                            </div>
                            <button className="btn btn-primary" onClick={this.convertLead}>Convert Lead</button>&nbsp;
                            <button className="btn btn-primary" onClick={() => this.setState({leadConvertModalIsOpen: false})}>Cancel</button>
                        </div>
                        :
                        ''
                    }
                    {   
                        this.state.leadConvertProcessing ? 
                        <div className="mt-3 text-center text-white">
                            <h2>Processing Lead Conversion<br/>Please Hold</h2>
                            <div className={css.LeadDetails__ConvertingLead}></div>
                        </div>
                        :
                        ''
                    }
                    {
                        this.state.leadConvertFailed ?
                        <div className="mt-3 text-center text-white">
                            <h2>Lead Failed to Convert</h2>
                            <p>Please reach out to Sales Support and include the following error message:<br/><br/>{this.state.leadConvertError}</p>
                            <button className="btn btn-primary" type="button" onClick={() => this.setState({
                                leadConvertModalIsOpen: false,
                                leadConvertFailed: false,
                                leadConvertProcessing: false,
                                leadConvertConfirm: true})}>Continue</button>
                        </div>
                        :
                        ''
                    }
                    {
                        this.state.leadConvertSuccess ?
                        <div className="mt-3 text-center text-white">
                            <h2>Lead Converted Successfully!</h2>
                            <p>The Converted Lead Should Now Be In Your Customers Section</p>
                            <Link to='/customers'>
                                <button className="btn btn-primary" type="button">Continue</button>
                            </Link>
                        </div>
                        :
                        ''
                    }
                </Modal>

                {/* ---------- Check Address/Aurora Modal: ---------- */}
                <Modal
                    isOpen={this.state.checkAddressModal}
                    onRequestClose={() => this.setState({checkAddressModal: false})}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                        },
                        content: {
                            background: 'rgba(53, 53, 53)',
                        }
                    }}
                >
                    <div className={this.state.checkingAddress ? "mt-3 text-center text-white" : "d-none"}>
                        <h2>Confirm Customer Address</h2>
                        <p>{this.state.lead.Name}</p>
                        <p>{this.state.lead.Street}, {this.state.lead.City}, {this.state.lead.State}, {this.state.lead.PostalCode}</p>
                        <button className="btn btn-primary" onClick={this.createAuroraSystem}>Create Design</button>&nbsp;
                        <button className="btn btn-primary" onClick={() => this.setState({checkAddressModal: false})}>Close</button>
                    </div>

                    <div className={this.state.checkingAddress ? "d-none" : "mt-3 text-center text-white"}>
                        <div className={this.state.creatingAuroraProject ? '' : 'd-none'}>
                            <h2>Creating Aurora Project<br/>Please Hold</h2>
                            <div className={css.LeadDetails__ConvertingLead}></div>
                        </div>
                        <div className={this.state.creatingAuroraProject ? 'd-none' : ''}>
                            <h2>Finished Creating Aurora Project</h2>
                            <button className="btn btn-primary" onClick={() => this.setState({checkAddressModal: false})}>Done</button>
                        </div>
                    </div>
                </Modal>

                {/* ---------- Missing Closer Modal: ---------- */}
                <Modal
                    isOpen={this.state.missingCloserModal}
                    onRequestClose={() => this.setState({missingCloserModal: false})}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                        },
                        content: {
                            background: 'rgba(53, 53, 53)',
                        }
                    }}
                >
                    <div className={this.state.checkingAddress ? "mt-3 text-center text-white" : "d-none"}>
                        <h2>There are two reps on the lead but no closer has been set</h2>
                        <h2>Please set a closer first before creating Aurora design</h2>
                        <button className="btn btn-primary" onClick={() => this.setState({missingCloserModal: false})}>Close</button>
                    </div>
                </Modal>

                {/* ---------- Credit Check Modal: ---------- */}
                <Modal
                    isOpen={this.state.creditCheckModal}
                    onRequestClose={() => this.setState({
                        creditCheckModal: false,
                        creditCheckFailed: false,
                        creditAPIError: ''
                    })}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                        },
                        content: {
                            background: 'rgba(53, 53, 53)',
                        }
                    }}
                >
                    <div className={css.LeadDetails__CreditModal}>
                        <h2>Credit Check</h2>
                        <p>{this.state.lead.Name}</p>
                        <p>{this.state.lead.Street}, {this.state.lead.City}, {this.state.lead.State}, {this.state.lead.PostalCode}</p>
                        <label>DOB*</label>&nbsp;&nbsp;
                        <input className={css.LeadDetails__Date} type='date' max="2004-01-01" onChange={(e) => this.setState({dobCredit: e.target.value})}></input><br/>
                        <div className={css.LeadDetails__Error}>
                            <p>{this.state.dobCreditError}</p>
                        </div>
                        <p>Result: {this.state.creditResult}</p>
                        {
                            this.state.creditCheckFailed ?
                            <div className="mt-3 text-center text-white">
                                <p>Credit Failed To Run<br/>{this.state.creditAPIError}</p>
                            </div>
                            :
                            ''
                        }
                        <button className="btn btn-primary" disabled={this.state.runCreditDisabled} onClick={this.creditCheck}>Run Credit</button>&nbsp;
                        <button className="btn btn-primary" onClick={() => this.setState({
                            creditCheckModal: false,
                            dobCreditError: '',
                            dobCredit: '',
                            creditCheckFailed: false,
                            creditAPIError: ''
                        })}>Close</button>
                    </div>
                </Modal>

                {/* ---------- Title Check Modal: ---------- */}
                <Modal
                    isOpen={this.state.titleCheckModal}
                    onRequestClose={() => this.setState({titleCheckModal: false})}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                        },
                        content: {
                            background: 'rgba(53, 53, 53)',
                        }
                    }}
                >
                    <div className='text-white text-center'>
                        <h2>Title Check</h2>
                        <p>{this.state.lead.Name}</p>
                        <p>{this.state.lead.Street}, {this.state.lead.City}, {this.state.lead.State}, {this.state.lead.PostalCode}</p>
                        <p>Result: {this.state.titleCheckResult}</p>
                        <p>Primary Title: {this.state.primaryTitle}</p>
                        <p>Secondary Title: {this.state.secondaryTitle}</p>
                        <p>Home Type on Title: {this.state.homeType}</p>
                        <button className="btn btn-primary" disabled={this.state.titleCheckButtonDisabled} onClick={this.titleCheck}>Run Title Check</button>&nbsp;
                        <button className="btn btn-primary" onClick={() => this.setState({titleCheckModal: false})}>Close</button>
                    </div>
                </Modal>

                {/* ---------- Create And Send CPUC Modal: ---------- */}
                <Modal
                    isOpen={this.state.cpucModalIsOpen}
                    onRequestClose={() => this.setState({cpucModalIsOpen: false})}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                        },
                        content: {
                            background: 'rgba(53, 53, 53)',
                        }
                    }}
                >
                    {
                        this.state.cpucConfirm ?

                        <div className="mt-3 text-center text-white">
                            <p className={this.state.createdDoc === 'green' ? 'text-primary' : this.state.createdDoc === 'red' ? 'text-danger' : 'text-white'}>Creating Document</p>
                            <p><FontAwesomeIcon icon={faEllipsisV} /></p>
                            <p className={this.state.docStatus === 'green' ? 'text-primary' : this.state.docStatus === 'red' ? 'text-danger' : 'text-white'}>Populating Fields</p>
                            <p><FontAwesomeIcon icon={faEllipsisV} /></p>
                            <p className={this.state.sentDoc === 'green' ? 'text-primary' : this.state.sentDoc === 'red' ? 'text-danger' : 'text-white'}>Sending Document</p>
                            <div className={this.state.sentDoc === 'green' || this.state.sentDoc === 'red' || this.state.docStatus === 'red' || this.state.createdDoc === 'red' ? 'd-none' : css.LeadDetails__SendingAgreement}></div>
                            <div className={this.state.createdDoc === 'red' ? '' : 'd-none'}><p>Failed to Create Document<br/>Please Try Refreshing Page or Contact Sales Support</p></div>
                            <div className={this.state.docStatus === 'red' || this.state.sentDoc === 'red' ? '' : 'd-none'}><p>Failed to Send Document<br/>Please Contact Sales Support to Try Manually Sending Document</p></div>
                            <button className={this.state.sentDoc === 'green' || this.state.sentDoc === 'red' || this.state.docStatus === 'red' || this.state.createdDoc === 'red' ? 'btn btn-primary' : 'd-none'} type="button" onClick={() => this.setState({
                                cpucModalIsOpen: false,
                                cpucConfirm: false,
                                createdDoc: '',
                                docStatus: '',
                                sentDoc: ''
                                })}>Continue</button>
                        </div>
                        :
                        <div className="mt-3 text-center text-white">
                            <h2>Create and Send CPUC to Customer</h2>
                            <p>Please Select Rep to Add on CPUC</p>
                            <div className='pb-3'>
                                <select value={this.state.repIdForContract} onChange={(event) => this.setState({repIdForContract: event.target.value})}>
                                    <option value=""></option>
                                    {this.state.contractReps.map((option) => <option key={option.value} value={option.id}>{option.value}</option>)}
                                </select>
                            </div>
                            <button className="btn btn-primary" type="button" onClick={() => this.getRepContactForDocs('cpuc')}>Continue</button>&nbsp;
                            <button className="btn btn-primary" type="button" onClick={() => this.setState({cpucModalIsOpen: false})}>Cancel</button>
                        </div>
                    }
                </Modal>

                {/* ---------- Agreement Modal: ---------- */}
                <Modal
                    isOpen={this.state.agreementProcessModal}
                    onRequestClose={() => this.setState({agreementProcessModal: false})}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                        },
                        content: {
                            background: 'rgba(53, 53, 53)',
                        }
                    }}
                >
                    {
                        this.state.agreementConfirm ?
                        <div className="mt-3 text-center text-white">
                            <p className={this.state.createdContract === 'green' ? 'text-primary' : this.state.createdContract === 'red' ? 'text-danger' : 'text-white'}>Creating Contract</p>
                            <p><FontAwesomeIcon icon={faEllipsisV} /></p>
                            <p className={this.state.createdDoc === 'green' ? 'text-primary' : this.state.createdDoc === 'red' ? 'text-danger' : 'text-white'}>Creating PandaDoc Document</p>
                            <p><FontAwesomeIcon icon={faEllipsisV} /></p>
                            <p className={this.state.docStatus === 'green' ? 'text-primary' : this.state.docStatus === 'red' ? 'text-danger' : 'text-white'}>Populating Fields</p>
                            <p><FontAwesomeIcon icon={faEllipsisV} /></p>
                            <p className={this.state.sentDoc === 'green' ? 'text-primary' : this.state.sentDoc === 'red' ? 'text-danger' : 'text-white'}>Sending Document</p>
                            <div className={this.state.sentDoc === 'green' || this.state.sentDoc === 'red' || this.state.docStatus === 'red' || this.state.createdDoc === 'red' ? 'd-none' : css.LeadDetails__SendingAgreement}></div>
                            <div className={this.state.createdDoc === 'red' ? '' : 'd-none'}><p>Failed to Create PandaDoc<br/>Please Try Refreshing Page or Contact Sales Support</p></div>
                            <div className={this.state.docStatus === 'red' || this.state.sentDoc === 'red' ? '' : 'd-none'}><p>Failed to Send Document<br/>Please Contact Sales Support to Try Manually Sending Document</p></div>
                            <button className={this.state.sentDoc === 'green' || this.state.sentDoc === 'red' || this.state.docStatus === 'red' || this.state.createdDoc === 'red' ? 'btn btn-primary' : 'd-none'} type="button" onClick={() => this.setState({
                                agreementProcessModal: false,
                                agreementConfirm: false,
                                createdContract: '',
                                createdDoc: '',
                                docStatus: '',
                                sentDoc: ''
                                })}>Continue</button>
                        </div>
                        :
                        <div className='text-white text-center'>
                            <h2>Create and Send Agreement</h2>
                            <p>Please Select Rep to Add on Agreement</p>
                            <div className='pb-3'>
                                {
                                    this.state.agreementReps.length === 0 && this.state.lead.State !== 'TX' ? 
                                    <div>Please add an HIS Licensed Rep to the project in order to send the agreement.</div>
                                    :
                                    this.state.lead.State === 'TX' ? 
                                    <select value={this.state.repIdForContract} onChange={(event) => this.setState({repIdForContract: event.target.value})}>
                                        <option value=""></option>
                                        {this.state.contractReps.map((option) => <option key={option.value} value={option.id}>{option.value}</option>)}
                                    </select>
                                    :
                                    <select value={this.state.repIdForContract} onChange={(event) => this.setState({repIdForContract: event.target.value})}>
                                        <option value=""></option>
                                        {this.state.agreementReps.map((option) => <option key={option.value} value={option.id}>{option.value}</option>)}
                                    </select>
                                }
                            </div>
                            <button className="btn btn-primary" disabled={this.state.agreementReps.length === 0 && this.state.lead.State !== 'TX' ? true : false} onClick={() => this.getRepContactForDocs('agreement')}>Send Agreement</button>&nbsp;
                            <button className="btn btn-primary" onClick={() => this.setState({agreementProcessModal: false, sendAgreementDisabled: false})}>Close</button>
                        </div>
                    }
                </Modal>
            </div>
        );
    }
};


// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(LeadDetails);
